'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var Informed = require('informed');
var reactDom = require('react-dom');
var ReactSelect = _interopDefault(require('react-select'));
var classNames = _interopDefault(require('classnames'));
var Moment = require('moment');
var Moment__default = _interopDefault(Moment);
var uuid = require('uuid');
var Cookies = require('js-cookie');
var reactRouterDom = require('react-router-dom');

var Alert = function (_a) {
    var automationId = _a.automationId, _b = _a.style, style = _b === void 0 ? 'info' : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, onClose = _a.onClose, children = _a.children;
    if (!visible)
        return null;
    var icon = style === 'info'
        ? (React.createElement("div", { className: "icon" },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faInfoCircle })))
        : style === 'success'
            ? (React.createElement("div", { className: "icon" },
                React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCheckCircle })))
            : style === 'warning'
                ? (React.createElement("div", { className: "icon" },
                    React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faExclamationCircle })))
                : style === 'danger'
                    ? (React.createElement("div", { className: "icon" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimesCircle })))
                    : null;
    var dismiss = onClose
        ? (React.createElement("button", { className: "close", type: "button", "aria-label": "Close", onClick: onClose },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimes, size: "xs" })))
        : null;
    return (React.createElement("div", { className: "alert alert-dismissible alert-" + style, role: "alert", "data-automationid": automationId },
        icon,
        children,
        dismiss));
};

var Badge = function (_a) {
    var _b = _a.style, style = _b === void 0 ? 'primary' : _b, children = _a.children;
    return (React.createElement("span", { className: "badge badge-" + style + " badge-pill" }, children));
};

var format = function (value) {
    if (value < 1024)
        return { value: value.toString(), unit: 'b' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'Kb' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'Mb' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'Gb' };
    value = value / 1024;
    return { value: value.toPrecision(3), unit: 'Tb' };
};
var Bits = function (_a) {
    var value = _a.value, _b = _a.measurment, measurment = _b === void 0 ? '' : _b;
    var formatted = format(value);
    return React.createElement("span", { className: "format format-bits" },
        formatted.value,
        "\u00A0",
        React.createElement("span", { className: "text-muted text-weight-bold" },
            formatted.unit,
            measurment));
};

var Button = function (_a) {
    var automationId = _a.automationId, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.style, style = _c === void 0 ? 'primary' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, children = _a.children;
    return (React.createElement("button", { className: "btn btn-" + style, type: type, disabled: disabled, formNoValidate: true, onClick: onClick, "data-automationid": automationId }, children));
};

var format$1 = function (value) {
    if (value < 1024)
        return { value: value.toString(), unit: 'B' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'KB' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'MB' };
    value = value / 1024;
    if (value < 1024)
        return { value: value.toPrecision(3), unit: 'GB' };
    value = value / 1024;
    return { value: value.toPrecision(3), unit: 'TB' };
};
var Bytes = function (_a) {
    var value = _a.value, _b = _a.measurment, measurment = _b === void 0 ? '' : _b;
    var formatted = format$1(value);
    return React.createElement("span", { className: "format format-bytes" },
        formatted.value,
        "\u00A0",
        React.createElement("span", { className: "text-muted text-weight-bold" },
            formatted.unit,
            measurment));
};

var Card = function (_a) {
    var header = _a.header, footer = _a.footer, icon = _a.icon, children = _a.children;
    var headerWrapper = header && !icon
        ? (React.createElement("div", { className: "card-header bg-transparent" }, header))
        : null;
    var bodyWrapper = icon
        ? (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-sm-12 col-md-2 text-center" },
                React.createElement(reactFontawesome.FontAwesomeIcon, { icon: icon, size: "6x", color: "#00aeff" })),
            React.createElement("div", { className: "col" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" }, header),
                    React.createElement("div", { className: "col-12" },
                        React.createElement("hr", { className: "border-light" })),
                    React.createElement("div", { className: "col-12" }, children)))))
        : children;
    var footerWrapper = footer
        ? (React.createElement("div", { className: "card-footer text-right" }, footer))
        : null;
    return (React.createElement("div", { className: "card mb-4" },
        headerWrapper,
        React.createElement("div", { className: "card-body" }, bodyWrapper),
        footerWrapper));
};

var FormGroup = function (_a) {
    var label = _a.label, htmlFor = _a.htmlFor, children = _a.children;
    var labelWrapped = htmlFor
        ? (React.createElement("label", { className: "col-form-label col-xl-4 text-xl-right", htmlFor: htmlFor }, label))
        : (React.createElement("div", { className: "col-xl-4 text-xl-right font-weight-bold" }, label));
    return (React.createElement("div", { className: "row form-group" },
        labelWrapped,
        React.createElement("div", { className: "col-xl-8" }, children)));
};

var uniqueId = 0;
var useUniqueId = function () {
    var id = React.useState("rand" + uniqueId++)[0];
    return id;
};

var noValidation = function () { return undefined; };

var validateMany = function (validators) {
    return function (fieldValues, formValues) {
        for (var _i = 0, validators_1 = validators; _i < validators_1.length; _i++) {
            var validator = validators_1[_i];
            var result = validator(fieldValues, formValues);
            if (result)
                return result;
        }
    };
};

var select = "Select...";
var loading = "Loading...";
var required = "Required";
var invalidFormat = "Invalid format";
var invalidUrl = "Invalid URL";
var invalidEmail = "Invalid email";
var strings = {
	select: select,
	loading: loading,
	required: required,
	invalidFormat: invalidFormat,
	invalidUrl: invalidUrl,
	invalidEmail: invalidEmail
};

var validateRequired = function (required, message) {
    if (message === void 0) { message = strings.required; }
    return function (fieldValues) {
        if (!required)
            return;
        var values = Array.isArray(fieldValues)
            ? fieldValues
            : [fieldValues];
        if (values.length === 0)
            return message;
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            if (value == null || value === '')
                return message;
        }
    };
};

var Checkbox = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = _a.required, required = _g === void 0 ? false : _g, _h = _a.onValidate, onValidate = _h === void 0 ? noValidation : _h, _j = _a.requiredMessage, requiredMessage = _j === void 0 ? strings.required : _j;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback", style: { display: "block" } }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement("div", { className: "pt-1" },
            React.createElement("div", { className: "custom-control custom-checkbox" },
                React.createElement(Informed.Checkbox, { id: uniqueId, className: "custom-control-input " + invalidClass + " " + requiredClass, field: field, initialValue: initialValue, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, "data-automationid": automationId }),
                React.createElement("label", { className: "custom-control-label", htmlFor: uniqueId }),
                React.createElement("label", { className: "form-check-label", htmlFor: uniqueId }, placeholder))),
        errorMessage));
};

var validatePattern = function (regex, message) {
    if (message === void 0) { message = strings.invalidFormat; }
    return function (fieldValues) {
        var values = Array.isArray(fieldValues)
            ? fieldValues
            : [fieldValues];
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            if (regex && !regex.test("" + value))
                return message;
        }
    };
};

var validateEmail = function (message) {
    if (message === void 0) { message = strings.invalidEmail; }
    var email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return validatePattern(email, message);
};

var Email = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'email@example.com' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = _a.required, required = _g === void 0 ? false : _g, _h = _a.onValidate, onValidate = _h === void 0 ? noValidation : _h, _j = _a.requiredMessage, requiredMessage = _j === void 0 ? strings.required : _j, _k = _a.invalidFormatMessage, invalidFormatMessage = _k === void 0 ? strings.invalidEmail : _k;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        validateEmail(invalidFormatMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback" }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement(Informed.Text, { id: uniqueId, className: "form-control " + invalidClass + " " + requiredClass, type: "email", field: field, initialValue: initialValue, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, autoComplete: "off", "data-automationid": automationId }),
        errorMessage));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var rootId = 'root-modal';
var ModalWrapped = function (_a) {
    var automationId = _a.automationId, header = _a.header, footer = _a.footer, _b = _a.position, position = _b === void 0 ? 'centered' : _b, _c = _a.size, size = _c === void 0 ? 'lg' : _c, children = _a.children;
    React.useEffect(function () {
        var modalClass = 'modal-open';
        document.body.classList.add(modalClass);
        return function () { return document.body.classList.remove(modalClass); };
    }, []);
    var headerWrapper = header
        ? (React.createElement("div", { className: "modal-header" }, header))
        : null;
    var footerWrapper = footer
        ? (React.createElement("div", { className: "modal-footer" }, footer))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal-backdrop fade show" }),
        React.createElement("div", { className: "modal fade show", tabIndex: -1, role: "dialog", style: { display: "block" }, "data-automationid": automationId },
            React.createElement("div", { className: "modal-dialog modal-" + size + " modal-dialog-" + position },
                React.createElement("div", { className: "modal-content" },
                    headerWrapper,
                    React.createElement("div", { className: "modal-body" }, children),
                    footerWrapper)))));
};
var Modal = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, children = _a.children, rest = __rest(_a, ["visible", "children"]);
    var root = document.getElementById(rootId);
    return visible && root
        ? reactDom.createPortal(React.createElement(ModalWrapped, __assign({}, rest), children), root)
        : null;
};

var Password = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = _a.required, required = _g === void 0 ? false : _g, _h = _a.onValidate, onValidate = _h === void 0 ? noValidation : _h, _j = _a.requiredMessage, requiredMessage = _j === void 0 ? strings.required : _j;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback" }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement(Informed.Text, { id: uniqueId, className: "form-control " + invalidClass + " " + requiredClass, type: "password", field: field, initialValue: initialValue, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, autoComplete: "off", "data-automationid": automationId }),
        errorMessage));
};

var DefaultPageSize = 10;
var QueryContext = React.createContext({
    provider: '',
    fields: [],
    distinct: false,
    filters: [],
    orderBy: '',
    orderDirection: 'ascending',
    page: 0,
    pageSize: 0,
    pageTotal: 0,
    count: 0,
    data: [],
    refresh: function () { },
    filter: function () { },
    order: function () { },
    changePage: function () { },
});
var QueryProvider = QueryContext.Provider;
var useQuery = function () { return React.useContext(QueryContext); };
var Query = function (_a) {
    var provider = _a.provider, fields = _a.fields, _b = _a.distinct, distinct = _b === void 0 ? false : _b, _c = _a.initialFilters, initialFilters = _c === void 0 ? [] : _c, initialOrderBy = _a.initialOrderBy, _d = _a.initialOrderDirection, initialOrderDirection = _d === void 0 ? 'ascending' : _d, _e = _a.initialPage, initialPage = _e === void 0 ? 1 : _e, _f = _a.pageSize, pageSize = _f === void 0 ? DefaultPageSize : _f, children = _a.children;
    var _g = React.useState(initialFilters), filters = _g[0], setFilters = _g[1];
    var _h = React.useState(initialOrderBy), orderBy = _h[0], setOrderBy = _h[1];
    var _j = React.useState(initialOrderDirection), orderDirection = _j[0], setOrderDirection = _j[1];
    var _k = React.useState(initialPage), page = _k[0], setPage = _k[1];
    var _l = React.useState(0), pageTotal = _l[0], setPageTotal = _l[1];
    var _m = React.useState(0), count = _m[0], setCount = _m[1];
    var _o = React.useState([]), data = _o[0], setData = _o[1];
    React.useEffect(function () { return handleRefresh(); }, [fields, distinct, filters, orderBy, orderDirection, page, pageSize]);
    var handleRefresh = function () {
        fetch(provider, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                members: fields,
                distinct: distinct,
                filters: filters,
                order: {
                    member: orderBy,
                    direction: orderDirection,
                },
                page: {
                    current: page,
                    length: pageSize,
                },
            }),
        })
            .then(function (response) { return response.json(); })
            .then(function (json) {
            setPageTotal(json.page.total);
            setCount(json.count);
            setData(json.data);
        });
    };
    var handleFilter = function (filters) {
        setFilters(filters);
    };
    var handleOrder = function (member, direction) {
        setOrderBy(member);
        setOrderDirection(direction);
    };
    var handleChangePage = function (newPage) {
        newPage = newPage < 1 ? 1 : newPage;
        newPage = newPage > pageTotal ? pageTotal : newPage;
        setPage(newPage);
    };
    return (React.createElement(QueryProvider, { value: { provider: provider, fields: fields, distinct: distinct, filters: filters, orderBy: orderBy, orderDirection: orderDirection, page: page, pageSize: pageSize, pageTotal: pageTotal, count: count, data: data, refresh: handleRefresh, filter: handleFilter, order: handleOrder, changePage: handleChangePage } }, children));
};

var Range = function (_a) {
    var field = _a.field, min = _a.min, max = _a.max, automationId = _a.automationId, _b = _a.step, step = _b === void 0 ? 1 : _b, initialValue = _a.initialValue, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.autoFocus, autoFocus = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? false : _f, _g = _a.onValidate, onValidate = _g === void 0 ? noValidation : _g, _h = _a.requiredMessage, requiredMessage = _h === void 0 ? strings.required : _h;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var initialStringValue = '' + initialValue;
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback", style: { display: "block" } }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement("div", { className: "pt-1" },
            React.createElement(Informed.Text, { id: uniqueId, className: "custom-range " + invalidClass + " " + requiredClass, field: field, type: "range", min: min, max: max, step: step, initialValue: initialStringValue, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, autoComplete: "off", "data-automationid": automationId }),
            errorMessage)));
};

var Select = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? strings.select : _c, options = _a.options, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.multiple, multiple = _f === void 0 ? false : _f, _g = _a.autoFocus, autoFocus = _g === void 0 ? false : _g, _h = _a.required, required = _h === void 0 ? false : _h, _j = _a.onValidate, onValidate = _j === void 0 ? noValidation : _j, _k = _a.requiredMessage, requiredMessage = _k === void 0 ? strings.required : _k, _l = _a.loadingMessage, loadingMessage = _l === void 0 ? strings.loading : _l, _m = _a.onBlur, onBlur = _m === void 0 ? function () { } : _m;
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        onValidate,
    ]);
    var uniqueId = useUniqueId();
    var _o = Informed.useField({ field: field, validate: handleValidation }), ref = _o.ref, render = _o.render, fieldState = _o.fieldState, fieldApi = _o.fieldApi;
    var value = fieldState.value, error = fieldState.error;
    var setValue = fieldApi.setValue, setTouched = fieldApi.setTouched;
    var cleanOptions = options.map(function (option) { return typeof option === 'string' || !option
        ? { label: option, value: option }
        : option; });
    var cleanValues = Array.isArray(value)
        ? cleanOptions.filter(function (option) { return value.includes(option.value); })
        : cleanOptions.find(function (option) { return option.value === value; });
    var handleBlur = function (e) {
        setTouched(true);
        onBlur(e.target.value);
    };
    var handleChange = function (selected) {
        if (selected == null)
            setValue(null);
        else if (Array.isArray(selected))
            setValue(selected.map(function (select) { return select.value; }));
        else
            setValue(selected.value);
    };
    var errorMessage = error
        ? (React.createElement("div", { style: { display: 'block' }, className: "invalid-feedback" }, error))
        : null;
    return render(React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement(ReactSelect, { ref: ref, id: uniqueId, value: cleanValues, options: cleanOptions, isMulti: multiple, autoFocus: autoFocus, isDisabled: disabled, isLoading: loading, placeholder: placeholder, loadingMessage: function () { return loadingMessage; }, onChange: handleChange, onBlur: handleBlur, "data-automationid": automationId }),
        errorMessage));
};

var Switch = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.autoFocus, autoFocus = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? false : _f, _g = _a.onValidate, onValidate = _g === void 0 ? noValidation : _g, _h = _a.requiredMessage, requiredMessage = _h === void 0 ? strings.required : _h;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var initialStringValue = initialValue
        ? 'true'
        : undefined;
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback", style: { display: "block" } }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : null;
    var requiredClass = required
        ? 'is-required'
        : null;
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement("div", { className: "pt-1" },
            React.createElement("div", { className: "custom-control custom-switch" },
                React.createElement(Informed.Checkbox, { id: uniqueId, className: "custom-control-input " + invalidClass + " " + requiredClass, field: field, initialValue: initialStringValue, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, "data-automationid": automationId }),
                React.createElement("label", { className: "custom-control-label", htmlFor: uniqueId })),
            errorMessage)));
};

var RowContext = React.createContext({});
var useRow = function () { return React.useContext(RowContext); };
var Table = function (_a) {
    var data = _a.data, automationId = _a.automationId, _b = _a.displayFilterWarning, displayFilterWarning = _b === void 0 ? true : _b, _c = _a.children, children = _c === void 0 ? [] : _c;
    var _d = useQuery(), filters = _d.filters, filter = _d.filter;
    var handleClearFilters = function () { return filter([]); };
    var headers = children.map(function (child, index) { return (React.createElement("th", { className: "text-nowrap", "data-automationid": "header" + index }, child.props.header)); });
    var rows = data.map(function (value, index) { return (React.createElement(RowContext.Provider, { value: value },
        React.createElement("tr", { "data-automationid": "row" + index }, children.map(function (child, index) { return React.createElement("td", { className: "text-nowrap", "data-automationid": "column" + index }, child); })))); });
    var alert = displayFilterWarning && filters.length > 0
        ? (React.createElement("tr", null,
            React.createElement("td", { className: "alert alert-info", colSpan: children.length },
                React.createElement("div", { className: "icon" },
                    React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faInfoCircle })),
                "One or more filters are applied to the results. ",
                React.createElement(Button, { style: "link", onClick: handleClearFilters }, "Clear filters"))))
        : null;
    return (React.createElement("div", { className: "table-responsive rounded-top" },
        React.createElement("table", { className: "table table-striped table-hover", "data-automationid": automationId },
            React.createElement("thead", { className: "thead-dark" },
                React.createElement("tr", null, headers),
                alert),
            React.createElement("tbody", null, rows)),
        React.createElement(TablePagination, null)));
};
var Column = function (_a) {
    var field = _a.field, _b = _a.formatter, formatter = _b === void 0 ? function (value) { return value; } : _b;
    var row = useRow();
    var value = field
        ? row[field]
        : null;
    var formatted = formatter(value);
    return (React.createElement(React.Fragment, null, formatted));
};
var FilterHeader = function (_a) {
    var _b = _a.sorted, sorted = _b === void 0 ? 'unordered' : _b, _c = _a.filtered, filtered = _c === void 0 ? false : _c, onSort = _a.onSort, onFilter = _a.onFilter, children = _a.children;
    var sortIcon = sorted === "unordered"
        ? freeSolidSvgIcons.faSort
        : sorted === "descending"
            ? freeSolidSvgIcons.faSortDown
            : freeSolidSvgIcons.faSortUp;
    var sortedClass = sorted !== 'unordered'
        ? 'active'
        : '';
    var filteredClass = filtered
        ? 'active'
        : '';
    var sort = sorted || onSort
        ? React.createElement("button", { "data-automationid": "sort", className: "action " + sortedClass, disabled: !onSort, onClick: onSort },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: sortIcon }))
        : null;
    var filter = filtered || onFilter
        ? React.createElement("button", { "data-automationid": "filter", className: "action " + filteredClass, disabled: !onFilter, onClick: onFilter },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faFilter }))
        : null;
    return (React.createElement("div", { className: "query-header" },
        children,
        sort,
        filter));
};
var TablePagination = function () {
    var _a = useQuery(), page = _a.page, pageTotal = _a.pageTotal, changePage = _a.changePage;
    var firstPage = 1;
    var lastPage = pageTotal || 1;
    var jump = 2;
    var previousPage = page - 1;
    var nextPage = page + 1;
    var start = page - jump;
    var end = page + jump;
    var pages = [];
    if (start < firstPage) {
        end += start * -1 + 1;
    }
    if (end > lastPage) {
        start -= end - lastPage;
    }
    if (start < firstPage) {
        start = firstPage;
    }
    if (end > lastPage) {
        end = lastPage;
    }
    if (previousPage < firstPage) {
        previousPage = firstPage;
    }
    if (nextPage > lastPage) {
        nextPage = lastPage;
    }
    var _loop_1 = function (p) {
        var pageItemClasses = classNames("page-item", { active: p === page });
        pages.push(React.createElement("li", { key: "PageLink" + p, className: pageItemClasses },
            React.createElement("a", { className: "page-link", onClick: function () { return changePage(p); }, href: "#" }, p === start && p !== firstPage
                ? "..."
                : p === end && p !== lastPage
                    ? "..."
                    : p)));
    };
    for (var p = start; p <= end; p++) {
        _loop_1(p);
    }
    var firstPageDisabled = page === firstPage;
    var firstPageItemClasses = classNames("page-item", { disabled: firstPageDisabled });
    var lastPageDisabled = page === lastPage;
    var lastPageItemClasses = classNames("page-item", { disabled: lastPageDisabled });
    return (React.createElement("nav", { "aria-label": "Table pages" },
        React.createElement("ul", { className: "pagination" },
            React.createElement("li", { className: firstPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(firstPage); }, "aria-label": "First Page", href: firstPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleDoubleLeft })),
                    React.createElement("span", { className: "sr-only" }, "First"))),
            React.createElement("li", { className: firstPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(previousPage); }, "aria-label": "Previous Page", href: firstPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleLeft })),
                    React.createElement("span", { className: "sr-only" }, "Previous"))),
            pages,
            React.createElement("li", { className: lastPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(nextPage); }, "aria-label": "Next Page", href: lastPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleRight })),
                    React.createElement("span", { className: "sr-only" }, "Next"))),
            React.createElement("li", { className: lastPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(lastPage); }, "aria-label": "Last Page", href: lastPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleDoubleRight })),
                    React.createElement("span", { className: "sr-only" }, "Last"))))));
};

var Text = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = _a.required, required = _g === void 0 ? false : _g, pattern = _a.pattern, _h = _a.onValidate, onValidate = _h === void 0 ? noValidation : _h, appendElement = _a.appendElement, _j = _a.requiredMessage, requiredMessage = _j === void 0 ? strings.required : _j, _k = _a.invalidPatternMessage, invalidPatternMessage = _k === void 0 ? strings.invalidFormat : _k;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        validatePattern(pattern, invalidPatternMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback" }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    var inputGroupClass = classNames({ "input-group": appendElement });
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement("div", { className: inputGroupClass },
            React.createElement(Informed.Text, { id: uniqueId, className: "form-control " + invalidClass + " " + requiredClass, field: field, initialValue: initialValue, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, autoComplete: "off", "data-automationid": automationId }),
            appendElement ? React.createElement("div", { className: "input-group-append" },
                React.createElement("div", { className: "input-group-text" }, appendElement)) : null,
            errorMessage)));
};

var defaultTitle = '';
var Title = function (_a) {
    var _b = _a.title, title = _b === void 0 ? defaultTitle : _b, children = _a.children;
    React.useEffect(function () {
        document.title = title;
        return function () { return document.title = defaultTitle; };
    }, [title]);
    return (React.createElement(React.Fragment, null, children));
};

var FileUpload = function (_a) {
    var automationId = _a.automationId, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.required, required = _e === void 0 ? false : _e, pattern = _a.pattern, accept = _a.accept, rest = __rest(_a, ["automationId", "label", "placeholder", "disabled", "required", "pattern", "accept"]);
    var uniqueId = useUniqueId();
    var requiredClass = required
        ? 'is-required'
        : null;
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement("div", { className: "custom-file" },
            React.createElement("input", __assign({ id: uniqueId, className: "custom-file-input " + requiredClass, type: "file", disabled: disabled, required: required, accept: accept, "data-automationid": automationId }, rest)),
            React.createElement("label", { className: "custom-file-label", htmlFor: uniqueId }, placeholder))));
};

var Loading = function (_a) {
    var message = _a.message, _b = _a.size, size = _b === void 0 ? "6x" : _b;
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "col text-center pt-2 pb-2 text-primary" },
                React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCircleNotch, size: size, spin: true }),
                React.createElement("h5", { className: "mt-2" }, message)))));
};

var format$2 = function (accuracy) {
    if (accuracy === 'millisecond')
        return 'DD-MMM-YYYY HH:mm:ss.SSS';
    if (accuracy === 'second')
        return 'DD-MMM-YYYY HH:mm:ss';
    if (accuracy === 'minute')
        return 'DD-MMM-YYYY HH:mm';
    if (accuracy === 'hour')
        return 'DD-MMM-YYYY HH';
    if (accuracy === 'day')
        return 'DD-MMM-YYYY';
    if (accuracy === 'month')
        return 'MMM-YYYY';
    return 'YYYY';
};
var DateTime = function (_a) {
    var value = _a.value, _b = _a.accuracy, accuracy = _b === void 0 ? 'second' : _b, _c = _a.displayOffset, displayOffset = _c === void 0 ? true : _c;
    var offset = displayOffset
        ? ' (Z)'
        : '';
    var formatted = Moment.parseZone(value).format("" + format$2(accuracy) + offset);
    return (React.createElement("span", { className: "format format-date-time" },
        React.createElement("time", null, formatted),
        "\u00A0",
        React.createElement(reactFontawesome.FontAwesomeIcon, { className: "text-muted", icon: freeSolidSvgIcons.faClock })));
};

var validateUrl = function (message) {
    if (message === void 0) { message = strings.invalidUrl; }
    var url = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
    return validatePattern(url, message);
};

var Url = function (_a) {
    var field = _a.field, automationId = _a.automationId, _b = _a.initialValue, initialValue = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'https://example.com' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.autoFocus, autoFocus = _f === void 0 ? false : _f, _g = _a.required, required = _g === void 0 ? false : _g, _h = _a.onValidate, onValidate = _h === void 0 ? noValidation : _h, _j = _a.requiredMessage, requiredMessage = _j === void 0 ? strings.required : _j, _k = _a.invalidFormatMessage, invalidFormatMessage = _k === void 0 ? strings.invalidUrl : _k;
    var uniqueId = useUniqueId();
    var fieldState = Informed.useFieldState(field);
    var handleValidation = validateMany([
        validateRequired(required, requiredMessage),
        validateUrl(invalidFormatMessage),
        onValidate,
    ]);
    var errorMessage = fieldState.error
        ? (React.createElement("div", { className: "invalid-feedback" }, fieldState.error))
        : null;
    var invalidClass = fieldState.error
        ? 'is-invalid'
        : '';
    var requiredClass = required
        ? 'is-required'
        : '';
    return (React.createElement(FormGroup, { label: label, htmlFor: uniqueId },
        React.createElement(Informed.Text, { id: uniqueId, className: "form-control " + invalidClass + " " + requiredClass, type: "url", field: field, initialValue: initialValue, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, validate: handleValidation, autoComplete: "off", "data-automationid": automationId }),
        errorMessage));
};

var DatePicker = function (_a) {
    var value = _a.value, className = _a.className, onChange = _a.onChange, _b = _a.onBlur, onBlur = _b === void 0 ? null : _b, _c = _a.placeholder, placeholder = _c === void 0 ? null : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.required, required = _e === void 0 ? false : _e;
    return (React.createElement("input", { type: "date", max: "9999-12-31", className: className, placeholder: placeholder, value: value ? Moment__default(value).format("YYYY-MM-DD") : "", onChange: function (e) {
            onChange(e.target.value);
        }, onBlur: function (e) {
            if (onBlur) {
                onBlur(Moment__default(e.target.value).format("YYYY-MM-DD"));
            }
        }, disabled: disabled, required: required }));
};

var Success = function (_a) {
    var message = _a.message, _b = _a.size, size = _b === void 0 ? "6x" : _b;
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "col text-center pt-2 pb-2 text-success" },
                React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCheckCircle, size: size }),
                React.createElement("h5", { className: "mt-2" }, message)))));
};

var Error = function (_a) {
    var message = _a.message, _b = _a.size, size = _b === void 0 ? "6x" : _b;
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "col text-center pt-2 pb-2 text-danger" },
                React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faTimesCircle, size: size }),
                React.createElement("h5", { className: "mt-2" }, message)))));
};

var MatchFilterHeader = function (_a) {
    var title = _a.title, field = _a.field;
    var _b = React.useState(false), displayFilter = _b[0], setDisplayFilter = _b[1];
    var _c = useQuery(), provider = _c.provider, filters = _c.filters, filter = _c.filter, orderBy = _c.orderBy, orderDirection = _c.orderDirection, order = _c.order, changePage = _c.changePage;
    var ordered = orderBy === field
        ? orderDirection
        : 'unordered';
    var filtered = filters.some(function (filter) { return filter.member === field; });
    var currentFilter = filters.find(function (filter) { return filter.member === field && filter.condition === 'equal'; });
    var initialValues = currentFilter
        ? currentFilter.values
        : [];
    var handleSort = function () {
        var direction = 'ascending';
        if (orderDirection == 'ascending')
            direction = 'descending';
        order(field, direction);
    };
    var handleFilter = function () {
        setDisplayFilter(true);
    };
    var handleApply = function (values) {
        var newFilters = filters.filter(function (filter) { return filter.member !== field || filter.condition !== 'equal'; });
        if (values.length > 0)
            newFilters.push({ member: field, condition: 'equal', values: values });
        changePage(1);
        filter(newFilters);
        setDisplayFilter(false);
    };
    var modal = displayFilter
        ? (React.createElement(Query, { provider: provider, fields: [field], distinct: true, initialOrderBy: field, pageSize: 0 },
            React.createElement(Informed.Form, null,
                React.createElement(MatchFilterModal, { title: title, field: field, initialValues: initialValues, onApply: handleApply, onClose: function () { return setDisplayFilter(false); } }))))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterHeader, { key: "MatchFilter_" + title, sorted: ordered, onSort: handleSort, filtered: filtered, onFilter: handleFilter }, title),
        modal));
};
var MatchFilterModal = function (_a) {
    var title = _a.title, field = _a.field, initialValues = _a.initialValues, onApply = _a.onApply, onClose = _a.onClose;
    var data = useQuery().data;
    var _b = Informed.useFormApi(), setValue = _b.setValue, getState = _b.getState;
    var options = data
        .filter(function (option) { return option[field] && option[field] !== ''; })
        .map(function (option) { return typeof (option[field]) !== 'string'
        ? option[field].toString()
        : option[field]; });
    React.useEffect(function () { return setValue('match', initialValues); }, [data]);
    var handleApply = function () {
        var state = getState();
        if (state.invalid)
            return;
        var values = state.values.match;
        onApply(values);
    };
    var handleClear = function () {
        setValue("match", []);
        handleApply();
    };
    var header = (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: "text-primary" },
            title,
            " Filter"),
        React.createElement("button", { type: "button", className: "close", onClick: onClose, "aria-label": "Close" },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))));
    var footer = (React.createElement(React.Fragment, null,
        React.createElement(Button, { automationId: "apply", onClick: handleApply }, "Apply"),
        React.createElement(Button, { automationId: "clear", style: "danger", onClick: handleClear }, "Clear")));
    return (React.createElement(Modal, { header: header, footer: footer, size: "md" },
        React.createElement(Select, { automationId: "match", field: "match", label: "Match", multiple: true, options: options, autoFocus: true })));
};

var BooleanFilterHeader = function (_a) {
    var title = _a.title, field = _a.field, customLabels = _a.customLabels;
    var _b = React.useState(false), displayFilter = _b[0], setDisplayFilter = _b[1];
    var _c = useQuery(), provider = _c.provider, filters = _c.filters, filter = _c.filter, orderBy = _c.orderBy, orderDirection = _c.orderDirection, order = _c.order, changePage = _c.changePage;
    var ordered = orderBy === field
        ? orderDirection
        : 'unordered';
    var filtered = filters.some(function (filter) { return filter.member === field; });
    var currentFilter = filters.find(function (filter) { return filter.member === field && filter.condition === 'equal'; });
    var initialValues = currentFilter
        ? currentFilter.values
        : [];
    var handleSort = function () {
        var direction = 'ascending';
        if (orderDirection == 'ascending')
            direction = 'descending';
        order(field, direction);
    };
    var handleFilter = function () {
        setDisplayFilter(true);
    };
    var handleApply = function (values) {
        var newFilters = filters.filter(function (filter) { return filter.member !== field || filter.condition !== 'equal'; });
        if (values.length > 0)
            newFilters.push({ member: field, condition: 'equal', values: values });
        changePage(1);
        filter(newFilters);
        setDisplayFilter(false);
    };
    var modal = displayFilter
        ? (React.createElement(Query, { provider: provider, fields: [field], distinct: true, initialOrderBy: field, pageSize: 0 },
            React.createElement(Informed.Form, null,
                React.createElement(BooleanFilterModal, { title: title, initialValues: initialValues, customLabels: customLabels, onApply: handleApply, onClose: function () { return setDisplayFilter(false); } }))))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterHeader, { key: "BooleanFilter_" + title, sorted: ordered, onSort: handleSort, filtered: filtered, onFilter: handleFilter }, title),
        modal));
};
var BooleanFilterModal = function (_a) {
    var automationId = _a.automationId, title = _a.title, initialValues = _a.initialValues, customLabels = _a.customLabels, onApply = _a.onApply, onClose = _a.onClose;
    var data = useQuery().data;
    var _b = Informed.useFormApi(), setValue = _b.setValue, getState = _b.getState;
    var options = [{ label: customLabels[0], value: "true" }, { label: customLabels[1], value: "false" }];
    React.useEffect(function () { return setValue('match', initialValues); }, [data]);
    var handleApply = function () {
        var state = getState();
        if (state.invalid)
            return;
        var values = state.values.match;
        onApply(values);
    };
    var handleClear = function () {
        setValue('match', []);
        handleApply();
    };
    var header = (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: "text-primary" },
            title,
            " Filter"),
        React.createElement("button", { type: "button", className: "close", onClick: onClose, "aria-label": "Close" },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))));
    var footer = (React.createElement(React.Fragment, null,
        React.createElement(Button, { automationId: "apply", onClick: handleApply }, "Apply"),
        React.createElement(Button, { automationId: "clear", style: "danger", onClick: handleClear }, "Clear")));
    return (React.createElement(Modal, { header: header, footer: footer, size: "md", automationId: automationId },
        React.createElement(Select, { automationId: "match", field: "match", label: "Match", multiple: true, options: options, autoFocus: true })));
};

var DefaultPaging = {
    page: 1,
    size: 10,
};
var DefaultRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, {
                data: [],
                '@odata.count': 0,
            }];
    });
}); };
var QueryContext$1 = React.createContext({
    filters: [],
    ordering: [],
    paging: DefaultPaging,
    count: 0,
    data: [],
    applyFilters: function () { },
    applyOrdering: function () { },
    applyPaging: function () { },
    refresh: function () { },
    refreshing: false,
});
var QueryProvider$1 = QueryContext$1.Provider;
var useODataQuery = function () { return React.useContext(QueryContext$1); };
var ODataQuery = function (_a) {
    var _b = _a.initialFilters, initialFilters = _b === void 0 ? [] : _b, _c = _a.initialOrdering, initialOrdering = _c === void 0 ? [] : _c, _d = _a.initialPaging, initialPaging = _d === void 0 ? DefaultPaging : _d, _e = _a.onRefresh, onRefresh = _e === void 0 ? DefaultRefresh : _e, children = _a.children;
    var _f = React.useState(initialFilters), filters = _f[0], setFilters = _f[1];
    var _g = React.useState(initialOrdering), ordering = _g[0], setOrdering = _g[1];
    var _h = React.useState(initialPaging), paging = _h[0], setPaging = _h[1];
    var _j = React.useState(0), count = _j[0], setCount = _j[1];
    var _k = React.useState([]), data = _k[0], setData = _k[1];
    var _l = React.useState(true), refreshing = _l[0], setRefreshing = _l[1];
    React.useEffect(function () {
        handleRefresh();
    }, [filters, ordering, paging]);
    var handleRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        var page, size, skip, sanctifyValue, singleFilter, collectionFilter, filter, order, params, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRefreshing(true);
                    page = paging.page, size = paging.size;
                    skip = size * (page - 1);
                    sanctifyValue = function (x) {
                        // Guids (uuid), number and Boolean types shouldn't be wrapped in quotes
                        return uuid.validate(x) || typeof x === "boolean" || typeof x === "number" || Moment__default(x, "YYYY-MM-DD", true).isValid() ? x : "'" + x + "'";
                    };
                    singleFilter = function (f, x) {
                        return f.field + " " + f.condition + " " + sanctifyValue(x);
                    };
                    collectionFilter = function (f, x) {
                        var splitFieldParts = f.field.split("/");
                        return splitFieldParts[0] + "/any(x:x/" + splitFieldParts[1] + " " + f.condition + " " + sanctifyValue(x) + ")";
                    };
                    filter = filters.map(function (f) { return "(" + f.values.map(function (x) { return f.isCollection ? collectionFilter(f, x) : singleFilter(f, x); })
                        .join(' or ') + ")"; })
                        .join(' and ');
                    order = ordering.map(function (o) { return o.field + " " + o.condition; }).join(', ');
                    params = {
                        filter: filter.length === 0
                            ? undefined
                            : filter,
                        orderby: order.length === 0
                            ? undefined
                            : order,
                        top: size,
                        skip: skip,
                    };
                    return [4 /*yield*/, onRefresh(params)];
                case 1:
                    result = _a.sent();
                    setCount(result['@odata.count']);
                    setData(result.value);
                    setRefreshing(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var state = {
        filters: filters,
        ordering: ordering,
        paging: paging,
        count: count,
        data: data,
        applyFilters: setFilters,
        applyOrdering: setOrdering,
        applyPaging: setPaging,
        refresh: handleRefresh,
        refreshing: refreshing,
    };
    return (React.createElement(QueryProvider$1, { value: state }, children));
};

var ODataRowContext = React.createContext({});
var useODataRow = function () { return React.useContext(ODataRowContext); };
var ODataTable = function (_a) {
    var rowKeyField = _a.rowKeyField, data = _a.data, automationId = _a.automationId, children = _a.children;
    var _b = useODataQuery(), refreshing = _b.refreshing, filters = _b.filters, applyFilters = _b.applyFilters, count = _b.count;
    var headers = children.map(function (child, index) { return (React.createElement("th", { key: "header" + index, className: "text-nowrap", "data-automationid": "header" + index }, child.props.header)); });
    var rows = data.map(function (value, index) { return (React.createElement(ODataRowContext.Provider, { key: "row" + value[rowKeyField], value: value },
        React.createElement("tr", { "data-automationid": "row" + index }, children.map(function (child, index) { return React.createElement("td", { key: "column" + child.props.field, className: "text-nowrap", "data-automationid": "column" + index }, child); })))); });
    var refreshBody = refreshing && count < 1
        ? (React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: children.length },
                    React.createElement("p", { className: "text-center" }, "Querying for data")))))
        : null;
    var emptyBody = !refreshing && count < 1
        ? (React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: children.length },
                    React.createElement("p", { className: "text-center" }, "No data available")))))
        : null;
    var body = count > 0
        ? (React.createElement("tbody", { className: "" + (refreshing ? 'text-muted' : '') }, rows))
        : null;
    var alert = filters.length > 0
        ? (React.createElement("tr", null,
            React.createElement("td", { className: "alert alert-info", colSpan: children.length },
                React.createElement("div", { className: "icon" },
                    React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faInfoCircle })),
                "One or more filters are applied to the results. ",
                React.createElement(Button, { style: "link", onClick: function () { return applyFilters([]); } }, "Clear filters"))))
        : null;
    return (React.createElement("div", { className: "table-responsive rounded-top" },
        React.createElement("table", { className: "table table-striped table-hover", "data-automationid": automationId },
            React.createElement("thead", { className: "thead-dark" },
                React.createElement("tr", null, headers),
                alert),
            refreshBody,
            emptyBody,
            body),
        React.createElement(TablePagination$1, null)));
};
var ODataColumn = function (_a) {
    var field = _a.field, _b = _a.formatter, formatter = _b === void 0 ? function (value) { return value; } : _b;
    var row = useODataRow();
    var value = field
        ? row[field]
        : null;
    var formatted = field ? formatter(value) : formatter(row);
    return (React.createElement(React.Fragment, null, formatted));
};
var ODataFilterHeader = function (_a) {
    var _b = _a.sorted, sorted = _b === void 0 ? null : _b, _c = _a.filtered, filtered = _c === void 0 ? false : _c, _d = _a.isCollectionFilter, isCollectionFilter = _d === void 0 ? false : _d, onSort = _a.onSort, onFilter = _a.onFilter, children = _a.children;
    var sortIcon = sorted === null
        ? freeSolidSvgIcons.faSort
        : sorted === 'desc'
            ? freeSolidSvgIcons.faSortDown
            : freeSolidSvgIcons.faSortUp;
    var sortedClass = sorted !== null
        ? 'action active'
        : 'action';
    var filteredClass = filtered
        ? 'action active'
        : 'action';
    var sort = !isCollectionFilter && (sorted || onSort)
        ? React.createElement("button", { className: sortedClass, style: { display: "inline-block", paddingLeft: "8px" }, onClick: onSort },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: sortIcon }))
        : null;
    var filter = filtered || onFilter
        ? React.createElement("button", { className: filteredClass, style: { display: "inline-block", paddingLeft: "8px" }, onClick: onFilter },
            React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faFilter }))
        : null;
    return (React.createElement("div", { className: "query-header" },
        children,
        sort,
        filter));
};
var TablePagination$1 = function () {
    var _a = useODataQuery(), count = _a.count, paging = _a.paging, applyPaging = _a.applyPaging;
    var page = paging.page, size = paging.size;
    var pageTotal = Math.ceil(count / size);
    var firstPage = 1;
    var lastPage = pageTotal || 1;
    var jump = 2;
    var previousPage = page - 1;
    var nextPage = page + 1;
    var start = page - jump;
    var end = page + jump;
    var pages = [];
    var changePage = function (page) { return applyPaging(__assign(__assign({}, paging), { page: page })); };
    if (start < firstPage)
        end += start * -1 + 1;
    if (end > lastPage)
        start -= end - lastPage;
    if (start < firstPage)
        start = firstPage;
    if (end > lastPage)
        end = lastPage;
    if (previousPage < firstPage)
        previousPage = firstPage;
    if (nextPage > lastPage)
        nextPage = lastPage;
    var _loop_1 = function (p) {
        var pageItemClasses = classNames("page-item", { active: p === page });
        pages.push(React.createElement("li", { key: "PageLink" + p, className: pageItemClasses },
            React.createElement("a", { className: "page-link", onClick: function () { return changePage(p); }, href: "#" }, p === start && p !== firstPage
                ? "..."
                : p === end && p !== lastPage
                    ? "..."
                    : p)));
    };
    for (var p = start; p <= end; p++) {
        _loop_1(p);
    }
    var firstPageDisabled = page === firstPage;
    var firstPageItemClasses = classNames("page-item", { disabled: firstPageDisabled });
    var lastPageDisabled = page === lastPage;
    var lastPageItemClasses = classNames("page-item", { disabled: lastPageDisabled });
    return (React.createElement("nav", { "aria-label": "Table pages" },
        React.createElement("ul", { className: "pagination" },
            React.createElement("li", { className: firstPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(firstPage); }, "aria-label": "First Page", href: firstPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleDoubleLeft })),
                    React.createElement("span", { className: "sr-only" }, "First"))),
            React.createElement("li", { className: firstPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(previousPage); }, "aria-label": "Previous Page", href: firstPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleLeft })),
                    React.createElement("span", { className: "sr-only" }, "Previous"))),
            pages,
            React.createElement("li", { className: lastPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(nextPage); }, "aria-label": "Next Page", href: lastPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleRight })),
                    React.createElement("span", { className: "sr-only" }, "Next"))),
            React.createElement("li", { className: lastPageItemClasses },
                React.createElement("a", { className: "page-link", onClick: function () { return changePage(lastPage); }, "aria-label": "Last Page", href: lastPageDisabled ? null : "#" },
                    React.createElement("span", { "aria-hidden": "true" },
                        React.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faAngleDoubleRight })),
                    React.createElement("span", { className: "sr-only" }, "Last"))))));
};

var ODataMatchFilterModal = function (_a) {
    var title = _a.title, field = _a.field, _b = _a.isCollectionFilter, isCollectionFilter = _b === void 0 ? false : _b, options = _a.options, onClose = _a.onClose;
    var _c = React.useState([]), values = _c[0], setValues = _c[1];
    var _d = useODataQuery(), filters = _d.filters, applyFilters = _d.applyFilters, paging = _d.paging, applyPaging = _d.applyPaging;
    React.useEffect(function () {
        var currentValues = filters
            .filter(function (f) { return f.field === field && f.condition === 'eq'; })
            .flatMap(function (f) { return f.values; });
        setValues(currentValues);
    }, []);
    var handleApply = function () {
        var newFilters = filters.filter(function (f) { return f.field !== field; });
        if (values && values.length > 0)
            newFilters = __spreadArrays(newFilters, [{
                    field: field,
                    condition: 'eq',
                    values: values,
                    isCollection: isCollectionFilter,
                }]);
        applyPaging(__assign(__assign({}, paging), { page: 1 }));
        applyFilters(newFilters);
        onClose();
    };
    var handleClear = function () {
        applyPaging(__assign(__assign({}, paging), { page: 1 }));
        applyFilters(filters.filter(function (f) { return f.field !== field && f.condition !== 'eq'; }));
        onClose();
    };
    var footer = (React.createElement("div", { className: "modal-footer" },
        React.createElement("button", { className: "btn btn-primary", onClick: handleApply }, "OK"),
        React.createElement("button", { className: "btn btn-danger", onClick: handleClear }, "Clear")));
    return (React.createElement(Modal, { header: title + " Filter", footer: footer },
        React.createElement("label", null, title),
        React.createElement(ReactSelect, { name: "match", isMulti: true, classNamePrefix: "multiSelect", options: options, autoFocus: true, value: values.map(function (v) { return options.find(function (o) { return o.value === v; }); }), getOptionLabel: function (o) { return o.label; }, getOptionValue: function (o) { return o.value; }, onChange: function (o) { return setValues(o.map(function (v) { return v.value; })); } })));
};

var ODataMatchSortHeader = function (_a) {
    var title = _a.title, field = _a.field, _b = _a.isCollectionFilter, isCollectionFilter = _b === void 0 ? false : _b, options = _a.options, _c = _a.sortField, sortField = _c === void 0 ? null : _c;
    var _d = React.useState(false), display = _d[0], setDisplay = _d[1];
    var _e = useODataQuery(), filters = _e.filters, ordering = _e.ordering, applyOrdering = _e.applyOrdering;
    var _f = React.useState(), ordered = _f[0], setOrdered = _f[1];
    var _g = React.useState(false), filtered = _g[0], setFiltered = _g[1];
    sortField = (sortField !== null && sortField !== void 0 ? sortField : field);
    React.useEffect(function () {
        var filtered = filters.some(function (f) { return f.field === field && f.condition === 'eq'; });
        setFiltered(filtered);
    }, [filters]);
    React.useEffect(function () {
        var ordered = ordering.find(function (o) { return o.field === sortField; });
        setOrdered(ordered
            ? ordered.condition
            : null);
    }, [ordering]);
    var handleSort = function () {
        var direction = 'asc';
        if (ordered === 'asc')
            direction = 'desc';
        applyOrdering([{ field: sortField, condition: direction }]);
    };
    var handleFilter = function () {
        setDisplay(true);
    };
    var modal = display
        ? (React.createElement(ODataMatchFilterModal, { title: title, field: field, isCollectionFilter: isCollectionFilter, options: options, onClose: function () { return setDisplay(false); } }))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(ODataFilterHeader, { filtered: filtered, sorted: ordered, isCollectionFilter: isCollectionFilter, onFilter: handleFilter, onSort: handleSort }, title),
        modal));
};

var ODataDateMatchSortHeader = function (_a) {
    var title = _a.title, field = _a.field, _b = _a.sortField, sortField = _b === void 0 ? null : _b;
    var _c = React.useState(false), display = _c[0], setDisplay = _c[1];
    var _d = useODataQuery(), filters = _d.filters, ordering = _d.ordering, applyOrdering = _d.applyOrdering;
    var _e = React.useState(), ordered = _e[0], setOrdered = _e[1];
    var _f = React.useState(false), filtered = _f[0], setFiltered = _f[1];
    sortField = (sortField !== null && sortField !== void 0 ? sortField : field);
    React.useEffect(function () {
        var filtered = filters.some(function (f) { return f.field === field && (f.condition === 'ge' || f.condition === 'le'); });
        setFiltered(filtered);
    }, [filters]);
    React.useEffect(function () {
        var ordered = ordering.find(function (o) { return o.field === sortField; });
        setOrdered(ordered
            ? ordered.condition
            : null);
    }, [ordering]);
    var handleSort = function () {
        var direction = 'asc';
        if (ordered === 'asc')
            direction = 'desc';
        applyOrdering([{ field: sortField, condition: direction }]);
    };
    var handleFilter = function () {
        setDisplay(true);
    };
    var modal = display
        ? (React.createElement(ODataDateMatchFilterModal, { title: title, field: field, onClose: function () { return setDisplay(false); } }))
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(ODataFilterHeader, { filtered: filtered, sorted: ordered, onFilter: handleFilter, onSort: handleSort }, title),
        modal));
};
var ODataDateMatchFilterModal = function (_a) {
    var title = _a.title, field = _a.field, onClose = _a.onClose;
    var valueFormat = 'YYYY-MM-DD';
    var _b = React.useState(), valueFrom = _b[0], setValueFrom = _b[1];
    var _c = React.useState(), valueTo = _c[0], setValueTo = _c[1];
    var _d = useODataQuery(), filters = _d.filters, applyFilters = _d.applyFilters, paging = _d.paging, applyPaging = _d.applyPaging;
    React.useEffect(function () {
        var currentValueFrom = filters
            .filter(function (f) { return f.field === field && f.condition === 'ge'; })
            .flatMap(function (f) { return f.values; });
        setValueFrom(currentValueFrom.length > 0 ? currentValueFrom[0] : Moment__default().subtract(1, 'months').format(valueFormat));
        var currentValueTo = filters
            .filter(function (f) { return f.field === field && f.condition === 'le'; })
            .flatMap(function (f) { return f.values; });
        setValueTo(currentValueTo.length > 0 ? currentValueTo[0] : Moment__default().format(valueFormat));
    }, []);
    var handleApply = function () {
        var newFilters = filters.filter(function (f) { return f.field !== field; });
        newFilters = __spreadArrays(filters, [
            {
                field: field,
                condition: 'ge',
                values: [valueFrom],
                isCollection: false,
            }, {
                field: field,
                condition: 'le',
                values: [valueTo],
                isCollection: false,
            }
        ]);
        applyPaging(__assign(__assign({}, paging), { page: 1 }));
        applyFilters(newFilters);
        onClose();
    };
    var handleClear = function () {
        applyPaging(__assign(__assign({}, paging), { page: 1 }));
        applyFilters(filters.filter(function (f) { return f.field !== field; }));
        onClose();
    };
    var footer = (React.createElement("div", { className: "modal-footer" },
        React.createElement("button", { className: "btn btn-primary", onClick: handleApply }, "OK"),
        React.createElement("button", { className: "btn btn-danger", onClick: handleClear }, "Clear")));
    return (React.createElement(Modal, { header: title + " Filter", footer: footer },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: 'col-md-6 form-group' },
                React.createElement("label", null, "From"),
                React.createElement(DatePicker, { onChange: function (value) { return setValueFrom(value); }, value: valueFrom, className: 'form-control', placeholder: "DD-MM-YYYY" })),
            React.createElement("div", { className: 'col-md-6 form-group' },
                React.createElement("label", null, "To"),
                React.createElement(DatePicker, { onChange: function (value) { return setValueTo(value); }, value: valueTo, className: 'form-control', placeholder: "DD-MM-YYYY" })))));
};

var useSessionCookie = function (key) {
    var _a = React.useState(function () { return Cookies.get(key); }), cookie = _a[0], setCookie = _a[1];
    React.useEffect(function () {
        if (cookie)
            return Cookies.set(key, cookie);
        Cookies.remove(key);
    }, [cookie]);
    return [cookie, setCookie];
};

var mapParams = function (location) {
    var search = new URLSearchParams(location.search);
    var params = {};
    search.forEach(function (value, key) {
        params[key] = value;
    });
    return params;
};
var useUrlParams = function () {
    var location = reactRouterDom.useLocation();
    var _a = React.useState(function () { return mapParams(location); }), params = _a[0], setParams = _a[1];
    React.useEffect(function () { return setParams(mapParams(location)); }, [location]);
    return params;
};

var faStatStripXpress2 = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        100,
        100,
        [],
        "0059",
        "M 31.417969 10.753906 C 28.721969 10.753906 26.533203 12.943672 26.533203 15.638672 L 26.533203 84.960938 C 26.533203 87.656937 28.721969 89.845703 31.417969 89.845703 L 70.490234 89.845703 C 73.186234 89.845703 75.373047 87.655938 75.373047 84.960938 L 75.373047 15.638672 C 75.373047 12.943672 73.186234 10.753906 70.490234 10.753906 L 31.417969 10.753906 z M 35.236328 15.326172 L 66.623047 15.326172 C 67.164297 15.326172 67.679172 15.436109 68.148438 15.634766 C 68.617703 15.833422 69.041422 16.121439 69.396484 16.476562 C 69.751547 16.831687 70.039641 17.255203 70.238281 17.724609 C 70.436922 18.194016 70.546875 18.710453 70.546875 19.251953 L 70.546875 72.8125 C 70.546875 73.196 70.407982 73.571891 70.146484 73.933594 C 69.884986 74.295297 69.500523 74.644126 69.003906 74.976562 C 68.010672 75.641437 66.572312 76.239187 64.796875 76.742188 C 63.021437 77.245188 60.909109 77.652219 58.5625 77.933594 C 56.215891 78.214969 53.636437 78.371094 50.929688 78.371094 C 48.223188 78.371094 45.643344 78.214969 43.296875 77.933594 C 40.950406 77.652219 38.835922 77.245188 37.060547 76.742188 C 35.285172 76.239187 33.848688 75.641437 32.855469 74.976562 C 32.358859 74.644126 31.972434 74.295297 31.710938 73.933594 C 31.449441 73.571891 31.3125 73.196 31.3125 72.8125 L 31.3125 19.251953 C 31.3125 18.710453 31.422453 18.194016 31.621094 17.724609 C 31.819734 17.255203 32.107828 16.831688 32.462891 16.476562 C 32.817953 16.121437 33.239719 15.833422 33.708984 15.634766 C 34.17825 15.436109 34.695078 15.326172 35.236328 15.326172 z M 36.173828 16.541016 C 35.664828 16.541016 35.179562 16.645563 34.738281 16.835938 C 34.297 17.026312 33.900281 17.302328 33.566406 17.642578 C 33.232531 17.982828 32.962172 18.388266 32.775391 18.837891 C 32.588609 19.287516 32.484375 19.782281 32.484375 20.300781 L 32.484375 71.609375 C 32.484375 71.976625 32.613498 72.335223 32.859375 72.681641 C 33.105252 73.028059 33.468602 73.363219 33.935547 73.681641 C 34.869438 74.318484 36.221312 74.891172 37.890625 75.373047 C 39.559938 75.854922 41.545687 76.246031 43.751953 76.515625 C 45.958219 76.785219 48.384935 76.933594 50.929688 76.933594 C 53.474688 76.933594 55.899062 76.785219 58.105469 76.515625 C 60.311875 76.246031 62.299375 75.854922 63.96875 75.373047 C 65.638125 74.891172 66.989922 74.318484 67.923828 73.681641 C 68.390781 73.363219 68.752168 73.028059 68.998047 72.681641 C 69.243926 72.335223 69.373047 71.976625 69.373047 71.609375 L 69.373047 20.300781 C 69.373047 19.782281 69.270766 19.287516 69.083984 18.837891 C 68.897203 18.388266 68.626844 17.982828 68.292969 17.642578 C 67.959094 17.302328 67.562375 17.026312 67.121094 16.835938 C 66.679812 16.645563 66.194547 16.541016 65.685547 16.541016 L 36.173828 16.541016 z M 38.888672 21.599609 L 63.019531 21.599609 C 63.852031 21.599609 64.606219 21.936547 65.152344 22.482422 C 65.698469 23.028297 66.035156 23.782734 66.035156 24.615234 L 66.035156 56.181641 C 66.035156 57.014141 65.698469 57.766625 65.152344 58.3125 C 64.606219 58.858375 63.852031 59.197266 63.019531 59.197266 L 38.888672 59.197266 C 38.056172 59.197266 37.301734 58.858375 36.755859 58.3125 C 36.209984 57.766625 35.871094 57.014141 35.871094 56.181641 L 35.871094 24.615234 C 35.871094 23.782734 36.209984 23.028297 36.755859 22.482422 C 37.301734 21.936547 38.056172 21.599609 38.888672 21.599609 z M 42.933594 69.785156 L 42.945312 73.857422 L 37.744141 71.837891 L 42.933594 69.785156 z M 51.160156 69.785156 C 51.862656 69.785156 52.500062 70.070375 52.960938 70.53125 C 53.421813 70.992125 53.707031 71.627578 53.707031 72.330078 C 53.707031 73.032578 53.421811 73.670234 52.960938 74.130859 C 52.500062 74.591484 51.862656 74.876953 51.160156 74.876953 C 50.457656 74.876953 49.821953 74.591484 49.361328 74.130859 C 48.900703 73.670234 48.615234 73.032578 48.615234 72.330078 C 48.615234 71.627578 48.900703 70.992125 49.361328 70.53125 C 49.821953 70.070375 50.457656 69.785156 51.160156 69.785156 z M 59.4375 70.294922 L 64.625 72.347656 L 59.423828 74.367188 L 59.4375 70.294922 Z"
    ]
};

var faVitalograph = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        100,
        75,
        [],
        "0056",
        "M61.039,45.486C61.039,42.477 60.231,39.844 58.615,37.587C56.71,34.925 54.776,33.449 52.814,33.16C52.237,32.986 51.573,32.87 50.823,32.813C50.072,32.755 49.524,32.697 49.177,32.639C49.12,32.755 48.903,32.943 48.528,33.203C48.153,33.464 47.965,33.767 47.965,34.115C47.965,34.578 48.038,35.026 48.182,35.46C48.326,35.894 48.975,37.326 50.13,39.757C51.111,41.84 51.602,43.287 51.602,44.097C51.602,46.007 50.361,47.859 47.879,49.653C46.032,51.042 44.329,51.924 42.771,52.3C41.212,52.677 40.029,52.937 39.221,53.082C38.413,53.226 37.691,53.299 37.056,53.299C36.537,53.299 36.032,53.226 35.541,53.082C35.051,52.937 34.69,52.865 34.459,52.865C33.882,52.865 33.377,53.241 32.944,53.993C32.511,54.745 32.294,55.758 32.294,57.031C32.294,57.668 32.367,58.478 32.511,59.462C32.655,60.446 33.593,61.285 35.325,61.979C37.056,62.674 39.221,63.021 41.818,63.021C46.609,63.021 51.01,61.183 55.022,57.509C59.033,53.834 61.039,49.826 61.039,45.486ZM55.584,20.747C55.642,19.878 55.671,19.3 55.671,19.01C55.671,16.696 55.094,14.8 53.939,13.325C52.785,11.849 51.169,10.706 49.091,9.896C48.629,9.722 47.648,9.563 46.147,9.418C44.646,9.274 43.55,9.201 42.857,9.201C40.722,9.201 39.509,9.433 39.221,9.896C39.105,10.127 39.048,10.503 39.048,11.024C39.048,12.066 39.25,12.992 39.654,13.802L41.385,17.101C41.674,17.274 41.876,17.419 41.991,17.535C42.395,17.94 42.655,18.432 42.771,19.01C42.886,19.589 42.785,20.124 42.468,20.616C42.15,21.108 41.645,21.615 40.952,22.135C39.913,23.003 37.489,24.682 33.68,27.17C32.41,28.038 30.505,29.282 27.965,30.903C26.061,32.292 24.502,33.869 23.29,35.634C22.078,37.399 21.472,39.034 21.472,40.538C21.472,42.737 21.717,44.358 22.208,45.399C22.698,46.441 23.636,47.425 25.022,48.351C25.772,48.814 26.609,49.175 27.532,49.436C28.456,49.696 29.293,49.826 30.043,49.826C30.505,49.826 30.938,49.783 31.342,49.696C31.746,49.609 32.006,49.566 32.121,49.566C32.583,49.392 32.814,49.132 32.814,48.785C32.814,48.611 32.698,48.119 32.468,47.309C32.237,46.499 32.121,45.804 32.121,45.226C32.121,44.531 32.251,43.822 32.511,43.099C32.771,42.376 33.218,41.667 33.853,40.972C35.354,39.178 39.827,35.938 47.273,31.25C52.814,27.778 55.584,24.277 55.584,20.747ZM61.385,63.021C61.212,62.326 61.097,61.806 61.039,61.458C60.693,60.243 60.289,59.346 59.827,58.767C59.365,58.189 58.99,57.899 58.701,57.899C58.413,57.899 57.98,58.16 57.403,58.681C57.287,58.796 56.941,59.086 56.364,59.549C55.325,60.243 54.603,60.735 54.199,61.024C53.449,61.545 53.16,62.066 53.333,62.587C53.795,63.976 54.026,65.191 54.026,66.233C54.026,67.274 53.535,68.634 52.554,70.313C52.092,71.123 51.89,71.875 51.948,72.569C54.199,72.222 56.277,71.325 58.182,69.878C60.375,68.2 61.472,66.262 61.472,64.063C61.472,63.6 61.443,63.252 61.385,63.021ZM19.74,30.556C20.144,29.977 20.606,28.993 21.126,27.604C21.645,26.215 22.049,24.826 22.338,23.438C22.626,22.512 21.991,20.689 20.433,17.969C19.625,16.522 18.99,15.799 18.528,15.799C18.124,15.799 17.662,16.001 17.143,16.406C15.469,17.679 14.084,18.461 12.987,18.75C10.851,19.329 9.264,20.428 8.225,22.049C8.167,22.164 7.763,23.148 7.013,25L4.589,30.469C3.954,31.51 3.492,32.292 3.203,32.813C2.684,33.738 2.424,34.52 2.424,35.156C2.424,35.909 2.54,36.487 2.771,36.892C3.232,37.703 4.012,38.108 5.108,38.108C5.281,38.108 5.671,38.035 6.277,37.891C6.883,37.746 8.11,37.124 9.957,36.024C11.342,35.156 12.121,34.693 12.294,34.635C14.488,33.825 15.931,33.304 16.623,33.073C17.778,32.61 18.817,31.771 19.74,30.556ZM12.121,30.556C12.641,30.324 13.16,29.514 13.68,28.125C13.68,27.836 13.68,27.517 13.68,27.17C13.276,27.17 12.496,27.633 11.342,28.559C10.188,29.485 9.61,30.064 9.61,30.295C9.61,30.584 9.928,30.729 10.563,30.729C10.851,30.729 11.198,30.7 11.602,30.642C11.717,30.642 11.89,30.613 12.121,30.556ZM60.952,54.688C60.952,54.745 61.501,56.221 62.597,59.115C63.175,60.619 63.463,62.211 63.463,63.889C63.463,67.419 61.789,70.226 58.442,72.309C55.556,74.103 52.294,75 48.658,75C46.926,75 45.541,74.797 44.502,74.392C44.156,74.277 43.983,73.872 43.983,73.177C44.04,72.598 44.069,72.135 44.069,71.788C43.55,70.747 43.146,69.936 42.857,69.358C41.991,67.737 41.27,66.551 40.693,65.799C38.615,65.509 36.667,65.017 34.848,64.323C33.03,63.628 31.659,62.471 30.736,60.851C30.39,60.214 30.144,59.635 30,59.115C29.856,58.594 29.784,57.957 29.784,57.205C29.784,56.51 29.856,55.888 30,55.339C30.144,54.789 30.418,54.167 30.823,53.472C31.053,53.067 31.053,52.691 30.823,52.344C27.532,51.997 24.964,51.1 23.117,49.653C20.693,47.801 19.481,45.081 19.481,41.493C19.481,39.063 20.087,36.863 21.299,34.896C22.511,33.218 23.723,31.539 24.935,29.861C24.993,29.688 24.921,29.384 24.719,28.95C24.517,28.516 24.242,28.241 23.896,28.125C23.55,28.125 23.175,28.704 22.771,29.861C22.193,31.366 21.544,32.436 20.823,33.073C20.101,33.709 18.773,34.361 16.84,35.026C14.906,35.692 13.709,36.14 13.247,36.372C10.996,37.703 9.38,38.571 8.398,38.976C6.724,39.67 5.166,40.017 3.723,40.017C3.03,39.959 2.309,39.583 1.558,38.889C0.519,37.963 0,36.834 0,35.503C0,34.462 0.462,33.16 1.385,31.597C2.136,30.324 2.799,29.051 3.377,27.778C3.723,27.025 4.156,25.781 4.675,24.045C5.195,22.309 5.541,21.296 5.714,21.007C6.522,19.734 7.33,18.808 8.139,18.229C8.543,17.94 9.38,17.506 10.649,16.927C12.958,15.885 14.141,15.365 14.199,15.365C15.931,14.439 16.883,13.657 17.056,13.021C17.229,12.211 16.941,11.198 16.19,9.983C15.96,9.578 15.556,9.028 14.978,8.333C13.42,6.713 11.948,5.613 10.563,5.035C9.12,4.572 7.677,4.08 6.234,3.559C5.368,3.27 4.935,2.72 4.935,1.91C4.935,0.926 5.368,0.434 6.234,0.434L47.965,0.434C48.139,0.434 48.341,0.55 48.571,0.781C48.802,1.013 48.918,1.273 48.918,1.562C48.918,1.968 48.644,2.344 48.095,2.691C47.547,3.038 46.782,3.313 45.801,3.516C44.82,3.718 44.242,3.848 44.069,3.906C42.915,4.369 42.28,4.63 42.165,4.688C41.587,5.035 41.01,5.729 40.433,6.771C42.799,6.887 44.574,6.959 45.758,6.988C46.941,7.017 48.124,7.248 49.307,7.682C50.491,8.116 51.544,8.623 52.468,9.201C54.026,10.185 55.152,11.212 55.844,12.283C56.537,13.354 57.056,14.497 57.403,15.712C57.749,16.927 57.922,18.056 57.922,19.097C57.922,20.37 57.763,21.513 57.446,22.526C57.128,23.539 56.623,24.624 55.931,25.781C55.469,26.534 54.719,27.402 53.68,28.385C52.929,29.08 52.554,29.63 52.554,30.035C52.554,30.498 53.117,30.946 54.242,31.38C55.368,31.814 56.046,32.118 56.277,32.292C57.201,33.044 57.807,33.536 58.095,33.767C58.903,34.404 59.538,34.722 60,34.722C60.519,34.722 62.872,31.322 67.056,24.523C71.241,17.723 73.42,13.773 73.593,12.674C73.766,11.574 73.896,10.706 73.983,10.069C74.069,9.433 74.113,8.999 74.113,8.767C74.113,7.61 73.911,6.684 73.506,5.99C72.929,5.006 72.006,4.225 70.736,3.646C69.639,3.299 68.802,3.038 68.225,2.865C67.128,2.459 66.58,1.997 66.58,1.476C66.58,0.608 67.071,0.116 68.052,0L99.394,0C99.798,0.347 100,0.694 100,1.042C100,1.331 99.913,1.649 99.74,1.997C99.625,2.344 99.105,2.633 98.182,2.865C97.258,3.096 96.508,3.299 95.931,3.472C93.68,4.051 92.092,4.557 91.169,4.991C90.245,5.425 89.149,6.308 87.879,7.639C85.57,10.185 83.03,13.513 80.26,17.622C78.644,20.052 77.056,22.454 75.498,24.826L63.896,42.014C63.377,42.708 63.117,43.605 63.117,44.705C63.175,45.399 63.203,45.92 63.203,46.267C63.203,46.846 63.117,47.541 62.944,48.351C62.54,49.971 62.107,51.302 61.645,52.344C61.183,53.385 60.952,54.167 60.952,54.688Z"
    ]
};

var faVitaloJak1 = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        100,
        100,
        [],
        "0057",
        "M5.859,20.909C2.625,20.909 0,23.517 0,26.728L0,73.272C0,76.483 2.625,79.091 5.859,79.091L94.143,79.091C97.376,79.09 100,76.483 100,73.272L100,26.728C100,23.517 97.376,20.909 94.143,20.909L5.859,20.909ZM7.311,32.661L79.654,32.661C79.934,32.661 80.205,32.692 80.467,32.753C81.588,32.867 82.679,33.084 83.729,33.396C84.778,33.707 85.787,34.112 86.746,34.601C87.705,35.089 88.613,35.663 89.461,36.31C90.309,36.956 91.098,37.677 91.816,38.462C92.534,39.247 93.182,40.097 93.75,41.001C94.318,41.905 94.807,42.863 95.205,43.866C95.603,44.87 95.912,45.918 96.121,47.001C96.33,48.084 96.439,49.202 96.439,50.345C96.439,51.488 96.33,52.607 96.121,53.69C95.912,54.773 95.603,55.82 95.205,56.823C94.807,57.827 94.318,58.786 93.75,59.69C93.182,60.594 92.534,61.444 91.816,62.229C91.098,63.015 90.309,63.735 89.461,64.382C88.613,65.029 87.705,65.6 86.746,66.089C85.787,66.578 84.778,66.983 83.729,67.294C82.679,67.605 81.588,67.822 80.467,67.937C80.205,67.998 79.934,68.03 79.654,68.03L7.311,68.03C6.819,68.03 6.35,67.932 5.924,67.753C5.498,67.574 5.115,67.313 4.793,66.993C4.471,66.673 4.21,66.293 4.029,65.87C3.849,65.447 3.748,64.981 3.748,64.493L3.748,36.196C3.748,35.708 3.849,35.244 4.029,34.821C4.21,34.398 4.469,34.016 4.791,33.696C5.113,33.376 5.498,33.118 5.924,32.938C6.35,32.759 6.819,32.661 7.311,32.661ZM8.428,33.622C6.514,33.622 4.959,35.123 4.959,36.972L4.959,63.778C4.959,65.627 6.514,67.128 8.428,67.128L78.861,67.128C79.134,67.128 79.4,67.098 79.654,67.04C88.385,66.175 95.205,59.04 95.205,50.376C95.205,41.712 88.385,34.575 79.654,33.71C79.4,33.652 79.134,33.622 78.861,33.622L8.428,33.622ZM84.037,37.622C84.719,37.622 85.334,37.744 85.875,37.966C86.416,38.188 86.883,38.509 87.264,38.905C87.644,39.302 87.938,39.774 88.139,40.298C88.339,40.822 88.445,41.397 88.445,42.001C88.445,42.605 88.321,43.18 88.098,43.704C87.874,44.228 87.551,44.698 87.152,45.095C86.753,45.491 86.279,45.812 85.752,46.034C85.225,46.256 84.645,46.378 84.037,46.378C83.429,46.378 82.848,46.256 82.32,46.034C81.793,45.812 81.319,45.491 80.92,45.095C80.521,44.698 80.198,44.228 79.975,43.704C79.751,43.18 79.627,42.605 79.627,42.001C79.627,41.397 79.751,40.822 79.975,40.298C80.198,39.774 80.521,39.302 80.92,38.905C81.319,38.509 81.793,38.188 82.32,37.966C82.848,37.744 83.429,37.622 84.037,37.622ZM10.561,43.728L50.307,43.728C50.713,43.728 51.081,43.892 51.348,44.157C51.614,44.422 51.779,44.789 51.779,45.192L51.779,56.892C51.779,57.295 51.614,57.66 51.348,57.925C51.081,58.19 50.713,58.354 50.307,58.354L10.561,58.354C10.154,58.354 9.786,58.19 9.52,57.925C9.253,57.66 9.088,57.295 9.088,56.892L9.088,45.192C9.088,44.789 9.253,44.422 9.52,44.157C9.786,43.892 10.154,43.728 10.561,43.728ZM75.916,45.226C76.616,45.226 77.241,45.35 77.785,45.571C78.33,45.793 78.794,46.113 79.17,46.509C79.546,46.905 79.835,47.378 80.029,47.901C80.224,48.425 80.324,49 80.324,49.604C80.324,50.208 80.202,50.784 79.979,51.308C79.755,51.831 79.432,52.304 79.033,52.7C78.634,53.096 78.158,53.416 77.631,53.638C77.103,53.859 76.524,53.983 75.916,53.983C75.308,53.983 74.728,53.859 74.201,53.638C73.674,53.416 73.198,53.096 72.799,52.7C72.4,52.304 72.077,51.831 71.854,51.308C71.63,50.784 71.508,50.208 71.508,49.604C71.508,49 71.63,48.425 71.854,47.901C72.077,47.378 72.4,46.905 72.799,46.509C73.198,46.113 73.674,45.793 74.201,45.571C74.728,45.35 75.308,45.226 75.916,45.226ZM87.09,47.726C87.865,47.726 88.587,47.874 89.234,48.144C89.881,48.413 90.453,48.801 90.928,49.282C91.403,49.763 91.782,50.336 92.041,50.972C92.3,51.607 92.441,52.307 92.441,53.04C92.441,53.773 92.29,54.473 92.02,55.108C91.749,55.744 91.357,56.317 90.873,56.798C90.389,57.279 89.812,57.667 89.172,57.937C88.532,58.206 87.828,58.354 87.09,58.354C86.352,58.354 85.648,58.206 85.008,57.937C84.368,57.667 83.791,57.279 83.307,56.798C82.822,56.317 82.431,55.744 82.16,55.108C81.889,54.473 81.738,53.773 81.738,53.04C81.738,52.307 81.889,51.607 82.16,50.972C82.431,50.336 82.822,49.763 83.307,49.282C83.791,48.801 84.368,48.413 85.008,48.144C85.648,47.874 86.352,47.726 87.09,47.726ZM67.941,52.716C68.489,52.716 68.985,52.814 69.422,52.993C69.859,53.172 70.236,53.432 70.545,53.753C70.854,54.073 71.094,54.456 71.258,54.88C71.421,55.304 71.508,55.768 71.508,56.257C71.508,56.746 71.407,57.212 71.227,57.636C71.046,58.06 70.786,58.442 70.463,58.763C70.14,59.083 69.755,59.343 69.328,59.522C68.901,59.702 68.433,59.8 67.941,59.8C67.449,59.8 66.98,59.702 66.553,59.522C66.126,59.343 65.741,59.083 65.418,58.763C65.095,58.442 64.833,58.06 64.652,57.636C64.472,57.212 64.373,56.746 64.373,56.257C64.373,55.768 64.472,55.304 64.652,54.88C64.833,54.456 65.095,54.073 65.418,53.753C65.741,53.432 66.126,53.172 66.553,52.993C66.98,52.814 67.449,52.716 67.941,52.716ZM61.609,58.845C62.175,58.845 62.681,58.945 63.121,59.124C63.562,59.303 63.938,59.563 64.242,59.884C64.547,60.204 64.78,60.585 64.938,61.009C65.095,61.432 65.176,61.899 65.176,62.388C65.176,62.877 65.077,63.343 64.896,63.767C64.716,64.19 64.454,64.571 64.131,64.892C63.808,65.212 63.425,65.472 62.998,65.651C62.571,65.831 62.102,65.931 61.609,65.931C61.117,65.931 60.647,65.831 60.221,65.651C59.794,65.472 59.411,65.212 59.088,64.892C58.765,64.571 58.503,64.19 58.322,63.767C58.142,63.343 58.043,62.877 58.043,62.388C58.043,61.899 58.142,61.432 58.322,61.009C58.503,60.585 58.765,60.204 59.088,59.884C59.411,59.563 59.794,59.303 60.221,59.124C60.647,58.945 61.117,58.845 61.609,58.845Z"
    ]
};

var faVitaloJak2 = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        100,
        100,
        [],
        "0058",
        "M70.881,84.972L29.119,84.972C26.238,84.972 23.899,82.633 23.899,79.752L23.899,20.847C23.899,17.966 26.238,15.627 29.119,15.627L70.881,15.627C73.762,15.627 76.101,17.966 76.101,20.847L76.101,79.752C76.101,82.633 73.762,84.972 70.881,84.972ZM74.557,75.349L25.427,75.349L25.427,78.311C25.427,81.022 27.628,83.224 30.34,83.224L69.644,83.224C72.355,83.224 74.557,81.022 74.557,78.311L74.557,75.349ZM38.772,54.688L32.965,54.688C32.564,54.689 32.239,55.014 32.239,55.414L32.239,61.221C32.239,61.622 32.564,61.947 32.965,61.947L38.772,61.947C39.173,61.947 39.498,61.622 39.498,61.221L39.498,55.414C39.498,55.014 39.173,54.689 38.772,54.688ZM48.295,54.688L42.488,54.688C42.087,54.689 41.762,55.014 41.762,55.414L41.762,61.221C41.762,61.622 42.087,61.947 42.488,61.947L48.295,61.947C48.695,61.947 49.021,61.622 49.021,61.221L49.021,55.414C49.021,55.014 48.695,54.689 48.295,54.688ZM57.569,54.688L51.762,54.688C51.361,54.689 51.036,55.014 51.036,55.414L51.036,61.221C51.036,61.622 51.361,61.947 51.762,61.947L57.569,61.947C57.97,61.947 58.295,61.622 58.295,61.221L58.295,55.414C58.295,55.014 57.97,54.689 57.569,54.688ZM66.99,54.688L61.183,54.688C60.782,54.688 60.457,55.014 60.457,55.414L60.457,61.221C60.457,61.622 60.782,61.947 61.183,61.947L66.99,61.947C67.391,61.947 67.716,61.622 67.716,61.221L67.716,55.414C67.716,55.014 67.391,54.688 66.99,54.688ZM60.139,32.075L39.845,32.075C38.839,32.075 38.022,32.892 38.022,33.898L38.022,48.477C38.022,49.483 38.839,50.3 39.845,50.3L60.139,50.3C61.145,50.3 61.961,49.483 61.961,48.477L61.961,33.898C61.961,32.892 61.145,32.075 60.139,32.075ZM35.698,28.798L31.019,28.798C30.925,28.799 30.849,28.875 30.849,28.968L30.849,30.327C30.849,30.421 30.925,30.497 31.019,30.497L35.698,30.497C35.792,30.497 35.868,30.421 35.868,30.327L35.868,28.968C35.868,28.875 35.792,28.799 35.698,28.798Z"
    ]
};

var faDiary = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        24,
        32,
        [],
        "0060",
        "M12,26.022007C12.828003,26.022007 13.5,26.694004 13.5,27.522007 13.5,28.35001 12.828003,29.022007 12,29.022007 11.171997,29.022007 10.5,28.35001 10.5,27.522007 10.5,26.694004 11.171997,26.022007 12,26.022007z M6,7L6,22.999999 18,22.999999 18,7z M4,5L20,5 20,24.999999 4,24.999999z M2,2L2,29.999999 22,29.999999 22,2z M0,0L24,0 24,31.999999 0,31.999999z"
    ]
};

var faPneumotrac = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        100,
        100,
        [],
        "0061",
        "M57.661,66.694L48.332,66.694C51.548,64.225 53.877,57.023 53.877,48.531C53.877,40.041 51.548,32.838 48.332,30.369L75.113,30.369C78.327,32.837 80.657,40.04 80.657,48.531C80.657,57.023 78.328,64.225 75.113,66.694L66.206,66.694L66.206,68.162C66.206,68.972 65.143,69.63 63.835,69.63C63.057,69.63 62.366,69.398 61.933,69.039C61.501,69.398 60.81,69.63 60.032,69.63C58.724,69.63 57.661,68.972 57.661,68.162L57.661,66.694ZM78.637,30.369L85.588,30.369C89.678,30.369 93,38.508 93,48.531C93,58.555 89.678,66.694 85.588,66.694L78.637,66.694C81.853,64.225 84.182,57.023 84.182,48.531C84.182,40.041 81.853,32.838 78.637,30.369ZM44.823,30.381C48.031,32.86 50.352,40.054 50.352,48.531C50.352,57.01 48.03,64.203 44.823,66.682L22.702,59.738L11.573,59.738C9.049,59.738 7,54.717 7,48.531C7,42.347 9.049,37.325 11.573,37.325L22.702,37.325L44.823,30.381ZM11.347,41.036C12.355,42.742 13.008,45.465 13.008,48.531C13.008,51.598 12.355,54.321 11.347,56.027C10.614,54.321 10.139,51.598 10.139,48.531C10.139,45.465 10.614,42.741 11.347,41.036Z"
    ]
};

var faFvc = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        104,
        82,
        [],
        "0061",
        "M83.400003,77.200001 L103.8,77.200001 103.8,81.799999 83.400003,81.799999 z M63.1,77.200001 L81.699999,77.200001 81.699999,81.799999 63.1,81.799999 z M42.1,77.200001 L61.000002,77.200001 61.000002,81.799999 42.1,81.799999 z M21.5,77.200001 L40.4,77.200001 40.4,81.799999 21.5,81.799999 z M0,61.700001 L4.6000004,61.700001 4.6000004,77.200001 19.4,77.200001 19.4,81.799999 0,81.799999 0,81.600002 0,77.200001 z M0,40.799999 L4.6000004,40.799999 4.6000004,59.700001 0,59.700001 z M0,20.400002 L4.6000004,20.400002 4.6000004,39 0,39 z M103.4,15.700001 L103.8,23.400002 41.1,26.799999 C34.699999,27 29.6,29.400002 25.6,33.900002 15,45.900002 15.700001,69.500004 16,75.200001 L12.1,75.200001 8.3000011,75.200001 C7.8999996,68.000004 7.5,42.799999 19.9,28.900002 25.300001,22.799999 32.4,19.5 40.9,19.200001 z M8.8999996,0.40000153 L19.4,0.40000153 19.4,3 12,3 12,6.6000004 18.4,6.6000004 18.4,9.2000008 12,9.2000008 12,15.700001 8.8999996,15.700001 8.8999996,15.600002 z M20.4,0.30000114 L23.699999,0.30000114 27.6,11.6 31.300001,0.30000114 34.6,0.30000114 29.1,15.600002 25.800001,15.600002 z M0,0.10000038 L4.6000004,0.10000038 4.6000004,18.299999 0,18.299999 z M42.699999,0 C44.6,0 46.1,0.60000038 47.199999,1.7000008 47.9,2.4000015 48.4,3.3000011 48.800001,4.5 L45.800001,5.2000008 C45.6,4.4000015 45.199999,3.8000011 44.699999,3.3000011 44.1,2.8000011 43.4,2.6000004 42.6,2.6000004 41.500002,2.6000004 40.6,3 39.800001,3.8000011 39.1,4.6000004 38.699999,5.9000015 38.699999,7.7000008 38.699999,9.6000004 39.000002,11 39.699999,11.800001 40.4,12.6 41.300001,13 42.4,13 43.199999,13 43.9,12.700001 44.500002,12.200001 45.199999,11.900002 45.6,11.1 45.9,10 L48.9,10.900002 C48.4,12.6 47.699999,13.800001 46.6,14.6 45.500002,15.400002 44.199999,15.799999 42.500002,15.799999 40.500002,15.799999 38.800001,15.1 37.500002,13.700001 36.199999,12.300001 35.500002,10.400002 35.500002,8 35.500002,5.5 36.199999,3.5 37.500002,2.1000004 38.800001,0.70000076 40.500002,0 42.699999,0 z"
    ]
};

var faPcf = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        106,
        83,
        [],
        "0062",
        "M84.800003,78.299999 L105.5,78.299999 105.5,82.999996 84.800003,82.999996 z M64.199997,78.299999 L83.099998,78.299999 83.099998,82.999996 64.199997,82.999996 z M42.900002,78.299999 L62.099998,78.299999 62.099998,82.999996 42.900002,82.999996 z M21.9,78.299999 L41.099998,78.299999 41.099998,82.999996 21.9,82.999996 z M0,62.700001 L4.6999998,62.700001 4.6999998,78.299999 19.799999,78.299999 19.799999,82.999996 0,82.999996 0,82.899998 0,78.299999 z M0,41.399998 L4.6999998,41.399998 4.6999998,60.600002 0,60.600002 z M0,20.599998 L4.6999998,20.599998 4.6999998,39.5 0,39.5 z M105.3,16 L105.7,23.799999 42,27.200001 C35.400002,27.399998 30.299999,29.799999 26.200001,34.399998 15.4,46.599998 16.1,70.499996 16.4,76.299999 L12.4,76.299999 8.5,76.299999 C8.1000004,68.999996 7.6999998,43.5 20.4,29.200001 25.900002,23 33,19.700001 41.700001,19.399998 z M12.4,3 L12.4,3.0999985 12.4,7.6999989 14.200001,7.6999989 C15.5,7.6999989 16.4,7.5999985 16.799999,7.3999996 17.200001,7.1999989 17.6,7 17.799999,6.5999985 18,6.1999989 18.200001,5.7999992 18.200001,5.2999992 18.200001,4.6999989 18,4.1999989 17.700001,3.7999992 17.4,3.3999996 16.9,3.1999989 16.4,3.0999985 16,3 15.200001,3 14,3 z M40.700001,0.29999924 L51.900002,0.29999924 51.900002,3.0999985 44,3.0999985 44,7 50.799999,7 50.799999,9.7999992 44,9.7999992 44,16.700001 40.700001,16.700001 40.700001,16.599998 z M9.1000004,0.29999924 L14.4,0.29999924 C16.4,0.29999924 17.700001,0.39999962 18.299999,0.5 19.200001,0.69999886 20,1.2999992 20.6,2.0999985 21.200001,2.8999996 21.5,4 21.5,5.2999992 21.5,6.2999992 21.299999,7.0999985 21,7.7999992 20.6,8.5 20.200001,9 19.6,9.3999996 19,9.7999992 18.5,10 17.9,10.199999 17.1,10.4 16,10.4 14.5,10.4 L12.4,10.4 12.4,16.5 9.1000004,16.5 z M31.400002,0.099998474 C33.400002,0.099998474 35,0.69999886 36.299999,1.8999996 37,2.5999985 37.599998,3.5999985 38,4.8999996 L34.700001,5.6999989 C34.5,4.8999996 34.099998,4.1999989 33.5,3.6999989 32.900002,3.1999989 32.099998,3 31.299999,3 30.099998,3 29.099998,3.3999996 28.400002,4.2999992 27.599998,5.1999989 27.299999,6.5999985 27.299999,8.5 27.299999,10.599998 27.700001,12 28.400002,12.9 29.099998,13.799999 30.099998,14.199999 31.299999,14.199999 32.200001,14.199999 32.900002,13.9 33.599998,13.4 34,12.699999 34.400002,11.799999 34.700001,10.599998 L37.900002,11.599998 C37.400002,13.4 36.599998,14.699999 35.5,15.599998 34.400002,16.5 32.900002,16.899998 31.200001,16.899998 29,16.899998 27.299999,16.200001 25.900002,14.699999 24.5,13.199999 23.799999,11.199999 23.799999,8.5999985 23.799999,5.8999996 24.5,3.7999992 25.900002,2.2999992 27.299999,0.79999924 29.099998,0.099998474 31.400002,0.099998474 z M0,0 L4.6999998,0 4.6999998,18.5 0,18.5 z"
    ]
};

var faDLco = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        106,
        83,
        [],
        "0062",
        "M84.800003,78.299999 L105.5,78.299999 105.5,82.999996 84.800003,82.999996 z M64.199997,78.299999 L83.099998,78.299999 83.099998,82.999996 64.199997,82.999996 z M42.900002,78.299999 L62.099998,78.299999 62.099998,82.999996 42.900002,82.999996 z M21.9,78.299999 L41.099998,78.299999 41.099998,82.999996 21.9,82.999996 z M0,62.700001 L4.6999998,62.700001 4.6999998,78.299999 19.799999,78.299999 19.799999,82.999996 0,82.999996 0,82.899998 0,78.299999 z M0,41.399998 L4.6999998,41.399998 4.6999998,60.600002 0,60.600002 z M0,20.599998 L4.6999998,20.599998 4.6999998,39.5 0,39.5 z M105.3,16 L105.7,23.799999 42,27.200001 C35.400002,27.399998 30.299999,29.799999 26.200001,34.399998 15.4,46.599998 16.1,70.499996 16.4,76.299999 L12.4,76.299999 8.5,76.299999 C8.1000004,68.999996 7.6999998,43.5 20.4,29.200001 25.900002,23 33,19.700001 41.700001,19.399998 z M12.4,3 L12.4,3.0999985 12.4,7.6999989 14.200001,7.6999989 C15.5,7.6999989 16.4,7.5999985 16.799999,7.3999996 17.200001,7.1999989 17.6,7 17.799999,6.5999985 18,6.1999989 18.200001,5.7999992 18.200001,5.2999992 18.200001,4.6999989 18,4.1999989 17.700001,3.7999992 17.4,3.3999996 16.9,3.1999989 16.4,3.0999985 16,3 15.200001,3 14,3 z M40.700001,0.29999924 L51.900002,0.29999924 51.900002,3.0999985 44,3.0999985 44,7 50.799999,7 50.799999,9.7999992 44,9.7999992 44,16.700001 40.700001,16.700001 40.700001,16.599998 z M9.1000004,0.29999924 L14.4,0.29999924 C16.4,0.29999924 17.700001,0.39999962 18.299999,0.5 19.200001,0.69999886 20,1.2999992 20.6,2.0999985 21.200001,2.8999996 21.5,4 21.5,5.2999992 21.5,6.2999992 21.299999,7.0999985 21,7.7999992 20.6,8.5 20.200001,9 19.6,9.3999996 19,9.7999992 18.5,10 17.9,10.199999 17.1,10.4 16,10.4 14.5,10.4 L12.4,10.4 12.4,16.5 9.1000004,16.5 z M31.400002,0.099998474 C33.400002,0.099998474 35,0.69999886 36.299999,1.8999996 37,2.5999985 37.599998,3.5999985 38,4.8999996 L34.700001,5.6999989 C34.5,4.8999996 34.099998,4.1999989 33.5,3.6999989 32.900002,3.1999989 32.099998,3 31.299999,3 30.099998,3 29.099998,3.3999996 28.400002,4.2999992 27.599998,5.1999989 27.299999,6.5999985 27.299999,8.5 27.299999,10.599998 27.700001,12 28.400002,12.9 29.099998,13.799999 30.099998,14.199999 31.299999,14.199999 32.200001,14.199999 32.900002,13.9 33.599998,13.4 34,12.699999 34.400002,11.799999&#xD;&#xA;34.700001,10.599998 L37.900002,11.599998 C37.400002,13.4 36.599998,14.699999 35.5,15.599998 34.400002,16.5 32.900002,16.899998 31.200001,16.899998 29,16.899998 27.299999,16.200001 25.900002,14.699999 24.5,13.199999 23.799999,11.199999 23.799999,8.5999985 23.799999,5.8999996 24.5,3.7999992 25.900002,2.2999992 27.299999,0.79999924 29.099998,0.099998474 31.400002,0.099998474 z M0,0 L4.6999998,0 4.6999998,18.5 0,18.5 z"
    ]
};

var faSvc = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        48,
        38,
        [],
        "0063",
        "M2.17,9.314L0,9.314L0,0.154L2.17,0.154L2.17,9.314ZM2.17,10.314L0,10.314L0,18.734L2.17,18.734L2.17,10.314ZM2.17,19.734L0,19.734L0,28.154L2.17,28.154L2.17,19.734ZM2.17,29.154L0,29.154L0,37.564L2.17,37.564L2.17,29.154ZM9.74,37.564L9.74,35.404L0,35.404L0,37.564L9.74,37.564ZM19.1,37.564L19.1,35.404L10.95,35.404L10.95,37.564L19.1,37.564ZM28.52,37.564L28.52,35.404L20.37,35.404L20.37,37.564L28.52,37.564ZM37.94,37.564L37.94,35.404L29.79,35.404L29.79,37.564L37.94,37.564ZM47.58,37.564L47.58,35.404L39.44,35.404L39.44,37.564L47.58,37.564ZM15.42,16.234L7.08,16.234L7.08,33.814L15.42,33.814L15.42,16.234ZM24.92,10.314L16.58,10.314L16.58,33.814L24.92,33.814L24.92,10.314ZM34.33,0.524L26,0.524L26,33.814L34.33,33.814L34.33,0.524ZM43.75,14.984L35.42,14.984L35.42,33.814L43.75,33.814L43.75,14.984ZM12.83,7.804L15.58,0.134L14.03,0.134L12.88,3.634C12.57,4.574 12.27,5.504 12.06,6.414C11.86,5.494 11.58,4.594 11.28,3.624L10.19,0.134L8.6,0.134L11.18,7.804L12.83,7.804ZM21.83,6.474C21.324,6.657 20.789,6.749 20.25,6.744C20.17,6.752 20.09,6.755 20.01,6.755C18.611,6.755 17.46,5.604 17.46,4.205C17.46,4.131 17.464,4.058 17.47,3.984C17.463,3.908 17.46,3.832 17.46,3.756C17.46,2.33 18.634,1.156 20.06,1.156C20.127,1.156 20.193,1.159 20.26,1.164C20.795,1.159 21.325,1.261 21.82,1.464L22.13,0.344C21.517,0.1 20.859,-0.013 20.2,0.014C20.09,0.005 19.98,0 19.869,0C17.708,0 15.929,1.779 15.929,3.94C15.929,3.965 15.93,3.989 15.93,4.014C15.93,6.354 17.47,7.874 20,7.874C20.706,7.896 21.409,7.781 22.07,7.534L21.83,6.474Z"
    ]
};

var faEcg = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        31,
        32,
        [],
        "0064",
        "M4.7224891,19.467431L4.7584193,19.5099C4.7460444,19.497399,4.7352164,19.484898,4.7257416,19.472397z M22.794585,0C24.767962,0 26.741461,0.87425897 28.240458,2.6227771 31.638476,6.5197946 31.638476,12.914848 28.240458,16.911872L15.35042,32.000001 4.9584319,19.908904 4.9584319,19.709899 9.9544132,20.008896C10.654426,20.008896 10.954415,19.609906 10.954415,19.609906 11.154427,19.009896 11.453439,19.609906 11.453439,19.609906L12.55244,24.805945C12.55244,24.905936,12.652416,25.004937,12.652416,25.104943L12.652416,25.504941C12.752454,25.504941 13.052441,25.904952 13.35243,25.904952 13.851454,25.904952 14.151442,25.304942 14.151442,24.705939L14.151442,24.605931 15.050431,15.712873C15.250444,15.01287,15.550432,15.912872,15.550432,15.912872L16.349444,22.207919C16.44942,22.207919 16.749409,22.806922 17.149434,22.806922 17.449422,22.806922 17.748435,22.407916 17.848471,22.00792L17.848471,21.907912 17.848471,21.607922C17.948447,21.008904 18.048423,20.008896 18.048423,20.008896 18.248435,19.309901 18.748437,19.109902 18.748437,19.109902L22.545441,19.109902C22.844453,19.809905 23.344453,20.208911 23.94443,20.208911 24.84348,20.208911 25.542456,19.309901 25.542456,18.110886 25.542456,16.911872 24.84348,16.012879 23.94443,16.012879 23.344453,16.012879 22.844453,16.311877 22.545441,17.111886L17.748435,17.111886C17.049458,17.111886,17.049458,15.812865,17.049458,15.812865L15.950457,6.8198C15.850421,6.0197908 15.550432,6.0197908 15.250444,6.0197908 14.851456,6.0197908 14.551407,5.919799 14.451431,6.8198L13.35243,18.310885C13.152417,19.309901,12.852429,18.609898,12.852429,18.609898L11.853404,14.013855C11.853404,13.513851 11.453439,13.214853 11.054452,13.214853 10.654426,13.214853 10.354439,13.314845 10.254402,14.213854L9.7554385,17.211878C9.7554385,18.210894,8.6553991,18.310885,8.6553991,18.310885L4.9584319,18.609898 5.0584075,18.609898C4.8583953,18.609898 4.6594202,18.809897 4.6594202,19.209895 4.6594202,19.284899 4.6594202,19.359896 4.7011854,19.434897L4.7224891,19.467431 2.5604174,16.911872C-0.8366231,13.014855 -0.8366231,6.6198017 2.4604411,2.6227771 3.9594066,0.92375889 5.9584338,0.024749983 7.9564235,0.024749756 9.9544132,0.024749983 11.853404,0.92375889 13.35243,2.6227771L15.35042,5.0207902 17.349446,2.6227771C18.847953,0.87425897,20.821208,0,22.794585,0z"
    ]
};

var faBloodPressure = {
    prefix: "fab",
    iconName: "edit",
    icon: [
        108,
        97,
        [],
        "0065",
        "M51.600001,76.376239 L51.600001,85.352984 51.693556,85.34199 C52.878127,85.174998 54.800002,84.612498 56.800002,82.799998 57.184378,82.45312 57.574027,82.058787 57.964087,81.6104 L58.153021,81.388835 57.652586,81.101893 C55.467299,79.810237 53.522742,78.336841 51.947447,76.738238 z M61.599997,43.299998 L72.300002,43.299998 C73.200003,43.299998 73.999999,44.100001 73.999999,44.999999 73.999999,45.900001 73.200003,46.7 72.300002,46.7 L61.599997,46.7 C60.700003,46.7 59.9,45.900001 59.9,44.999999 59.9,44.100001 60.700003,43.299998 61.599997,43.299998 z M32.800002,38.100001 L51.600001,38.100001 51.600001,69.188891 53.999999,72.299998 C55.443751,74.190623 57.572852,75.927638 60.098914,77.393237 L60.563704,77.654658 60.639479,77.505076 C63.319922,72.103908 65.412497,62.968753 64.999999,47.499999 L69.499999,47.400001 C69.859374,61.487506 68.255667,72.21709 64.688864,79.440249 L64.626753,79.563228 65.329321,79.831126 C69.038672,81.196094 73.093749,82.000003 76.9,82.000003 76.999999,82.000003 77.099997,82.000003 77.200003,82.000003 81.200003,82.000003 86.599997,81.000003 89.9,76.500003 95.4,69.100001 95.200003,57.799998 94.999999,47.900001 94.999999,45.499999 94.9,43.299998 94.9,41.100001 L99.4,41.2 C99.4,43.299998 99.4,45.499999 99.499999,47.799998 99.700003,58.399997 99.999999,70.500003 93.599997,79.2 90.099997,83.899997 84.499999,86.399997 77.300002,86.500003 77.099997,86.500003 76.999999,86.500003 76.9,86.500003 72.2125,86.500003 67.239356,85.423343 62.753043,83.609912 L62.269904,83.40787 62.084372,83.652347 C61.315627,84.642184 60.487494,85.524997 59.599997,86.299998 56.674998,88.98125 53.749999,89.74805 51.897753,89.941333 L51.600001,89.966907 51.600001,97.000003 32.800002,97.000003 32.800002,84.000003 37.600001,84.000003 C40.600001,84.000003 42.999999,81.600001 42.999999,78.600001 42.999999,75.600001 40.600001,73.2 37.600001,73.2 L32.800002,73.2 32.800002,59.799998 37.600001,59.799998 C40.600001,59.799998 42.999999,57.399997 42.999999,54.400001 42.999999,51.400001 40.600001,48.999999 37.600001,48.999999 L32.800002,48.999999 z M0,38.100001 L29.4,38.100001 29.4,48.900001 24.8,48.900001 C21.8,48.900001 19.4,51.299998 19.4,54.299998 19.4,57.299998 21.8,59.7 24.8,59.7 L29.4,59.7 29.4,73.000003 24.8,73.000003 C21.8,73.000003 19.4,75.399997 19.4,78.399997 19.4,81.399997 21.8,83.799998 24.8,83.799998 L29.4,83.799998 29.4,96.799998 0,96.799998 z M92.099997,29.2 L101.7,29.2 99.599997,39.900001 94.9,39.900001 z M66.463927,24.723456 C66.538725,24.719165 66.614455,24.720115 66.690627,24.726562 66.893752,24.743751 67.099997,24.799998 67.300002,24.900001 67.999999,25.299998 68.300002,26.2 67.9,26.999999 67.499999,27.7 66.599997,27.999999 65.800002,27.600001 65.099997,27.2 64.800002,26.299998 65.200003,25.499999 65.4625,25.040622 65.940337,24.753512 66.463927,24.723456 z M73.599997,14.3 L68.999999,24.7 66.700003,23.299998 z M66.599997,11.599999 C61.300002,11.599999 56.499999,14.400001 53.9,18.999999 49.999999,25.999999 52.499999,34.900001 59.499999,38.900001 61.700003,40.100001 64.099997,40.799998 66.599997,40.799998 71.9,40.799998 76.700003,37.999999 79.300002,33.400001 83.200003,26.400001 80.700003,17.499999 73.700003,13.499999 71.499999,12.3 69.099997,11.599999 66.599997,11.599999 z M66.499999,9.9000006 C69.300002,9.9000006 71.999999,10.599999 74.499999,11.999999 82.300002,16.400001 85.099997,26.400001 80.700003,34.2 77.9,39.400001 72.4,42.499999 66.499999,42.499999 63.700003,42.499999 60.999999,41.799998 58.499999,40.400001 50.699999,35.999999 47.9,25.999999 52.300002,18.2 55.199999,13.099999 60.599997,9.9000006 66.499999,9.9000006 z M96.599997,0 C103.1,0 108.5,6.3000002 108.5,13.999999 108.5,21.7 103.2,27.999999 96.599997,27.999999 89.999999,27.999999 84.599997,21.7 84.599997,13.999999 84.599997,6.3000002 89.999999,0 96.599997,0 z"
    ]
};

exports.Alert = Alert;
exports.Badge = Badge;
exports.Bits = Bits;
exports.BooleanFilterHeader = BooleanFilterHeader;
exports.BooleanFilterModal = BooleanFilterModal;
exports.Button = Button;
exports.Bytes = Bytes;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.Column = Column;
exports.DatePicker = DatePicker;
exports.DateTime = DateTime;
exports.Email = Email;
exports.Error = Error;
exports.FileUpload = FileUpload;
exports.FilterHeader = FilterHeader;
exports.FormGroup = FormGroup;
exports.Loading = Loading;
exports.MatchFilterHeader = MatchFilterHeader;
exports.MatchFilterModal = MatchFilterModal;
exports.Modal = Modal;
exports.ODataColumn = ODataColumn;
exports.ODataDateMatchFilterModal = ODataDateMatchFilterModal;
exports.ODataDateMatchSortHeader = ODataDateMatchSortHeader;
exports.ODataFilterHeader = ODataFilterHeader;
exports.ODataMatchFilterModal = ODataMatchFilterModal;
exports.ODataMatchSortHeader = ODataMatchSortHeader;
exports.ODataQuery = ODataQuery;
exports.ODataTable = ODataTable;
exports.Password = Password;
exports.Query = Query;
exports.Range = Range;
exports.Select = Select;
exports.Success = Success;
exports.Switch = Switch;
exports.Table = Table;
exports.Text = Text;
exports.Title = Title;
exports.Url = Url;
exports.faBloodPressure = faBloodPressure;
exports.faDLco = faDLco;
exports.faDiary = faDiary;
exports.faEcg = faEcg;
exports.faFvc = faFvc;
exports.faPcf = faPcf;
exports.faPneumotrac = faPneumotrac;
exports.faStatStripXpress2 = faStatStripXpress2;
exports.faSvc = faSvc;
exports.faVitaloJak1 = faVitaloJak1;
exports.faVitaloJak2 = faVitaloJak2;
exports.faVitalograph = faVitalograph;
exports.noValidation = noValidation;
exports.useODataQuery = useODataQuery;
exports.useODataRow = useODataRow;
exports.useQuery = useQuery;
exports.useRow = useRow;
exports.useSessionCookie = useSessionCookie;
exports.useUniqueId = useUniqueId;
exports.useUrlParams = useUrlParams;
exports.validateEmail = validateEmail;
exports.validateMany = validateMany;
exports.validatePattern = validatePattern;
exports.validateRequired = validateRequired;
exports.validateUrl = validateUrl;
//# sourceMappingURL=index.js.map
